// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:38:18.396Z
// Property: 1221 Broadway Lofts (ID: 6767906449167660)
// Collections: 57 amenities, 46 floorplans (live), 32 photos, 76 POIs, 3 reviews, 6 virtual tours, 6 office hours, 5 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162466",
  "multihub_property_id": "6767906449167660",
  "property_external_id": "530245",
  "property_zillow_url": "https://www.zillow.com/apartments/san-antonio-tx/1221-broadway-lofts/Cn4PdC/",
  "property_apartments_url": "https://www.apartments.com/1221-broadway-lofts-san-antonio-tx/rl3tkx1/",
  "property_google_business_url": "https://www.google.com/maps/place/1221+Broadway+Lofts/@29.4374556,-98.4793592,1993m/data=!3m2!1e3!4b1!4m6!3m5!1s0x865cf5f9e471dfc9:0x4bb7f4ac683971d5!8m2!3d29.4374556!4d-98.4793592!16s%2Fg%2F1v5fsb41?entry=ttu&g_ep=EgoyMDI2MDgxNi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "57292515134",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "2127534\np2094747",
  "property_status": null,
  "property_slug": "1221-broadway-lofts",
  "property_name": "1221 Broadway Lofts",
  "property_website_url": "https://www.1221broadway.com",
  "property_domain": "https://www.1221broadway.com",
  "property_address": "1221 Broadway",
  "property_full_address": "1221 Broadway, San Antonio, TX 78215",
  "property_address_1": "1221 Broadway",
  "property_address_2": null,
  "property_address_city": "San Antonio",
  "property_address_state": "TX",
  "property_address_zip_full": "78215",
  "property_address_zip": "78215",
  "property_address_country": "US",
  "property_address_county": "Bexar County",
  "property_neighborhood_address": "Downtown",
  "property_address_latitude": "29.4373711",
  "property_address_longitude": "-98.4792734",
  "property_email": "1221Manager@mox.living",
  "property_phone": "(726) 200-2832",
  "property_call_tracking_phone": "726-200-2832",
  "property_company_name": "Mox",
  "property_company_url": "https://www.mox.living/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Industrial loft character, Downtown San Antonio energy.</strong> Explore studio, one-, and two-bedroom <a href=\"/floor-plans\">loft apartments</a> with polished concrete floors, soaring ceilings, oversized windows, and distinct details—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see 1221 Broadway Lofts up close.</p>",
  "property_long_description": "Discover the ultimate urban living experience at 1221 Broadway Lofts in the heart of downtown San Antonio, TX. Our lofts in downtown San Antonio offer a perfect blend of industrial-chic design and modern luxury, creating a stylish retreat just two minutes from The Pearl and moments from the iconic River Walk. These loft apartments in San Antonio feature studio, one, and two-bedroom floor plans ranging from 548 to 1,295 square feet, each showcasing soaring 10'5\\\" ceilings, polished concrete floors, granite countertops, and expansive commercial-grade windows that flood your home with natural light.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd18-4eb9-769b-aacf-b1d66f9cce14.webp",
  "property_featured_image_media": {
    "alt_text": "Apartment building courtyard with a large swimming pool and lounge chairs.",
    "public_id": "019ffd18-4eb9-769b-aacf-b1d66f9cce14",
    "storage_key": "property/6767906449167660/019ffd18-4eb9-769b-aacf-b1d66f9cce14.webp",
    "width": 2560,
    "height": 1597
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "307",
  "property_year_built": "2014",
  "property_year_renovated": null,
  "property_walk_score": "69",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.46254071661238",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $200-400",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "0",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "We are proud partners with PetScreening.com! Pet rents range; please contact the office for details on rents and size/breed restrictions.",
  "property_pet_policy_description": "We understand that pets are part of the family. That's why your pets are welcome to join our community at 1221 Broadway.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://1221broadway.securecafeapplicant.com/onlineleasing/content3/access/1221-broadway-lofts0/login",
  "property_resident_portal_url": "https://1221broadway.securecafenet.com/residentservices/1221-broadway-lofts0/userlogin",
  "property_apply_now_url": "https://1221broadway.securecafeapplicant.com/onlineleasing/content3/access/1221-broadway-lofts0/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a01ba2-25c2-7251-8f77-3dc2ff31f52b.webp",
  "property_primary_logo_media": {
    "alt_text": "1212 TwentyOne Lofts logo",
    "public_id": "01a01ba2-25c2-7251-8f77-3dc2ff31f52b",
    "storage_key": "property/6767906449167660/01a01ba2-25c2-7251-8f77-3dc2ff31f52b.webp",
    "width": 1368,
    "height": 583
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a01ba2-254e-7005-9d96-8dd3525a3035.webp",
  "property_secondary_logo_media": {
    "alt_text": "12 W Elve 2 Wenty 1 Lofts logo",
    "public_id": "01a01ba2-254e-7005-9d96-8dd3525a3035",
    "storage_key": "property/6767906449167660/01a01ba2-254e-7005-9d96-8dd3525a3035.webp",
    "width": 1368,
    "height": 583
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd18-4dbd-72aa-b778-2a54d9828ac9.webp",
  "property_mono_white_logo_media": {
    "alt_text": "1212 Lofts logo",
    "public_id": "019ffd18-4dbd-72aa-b778-2a54d9828ac9",
    "storage_key": "property/6767906449167660/019ffd18-4dbd-72aa-b778-2a54d9828ac9.webp",
    "width": 1368,
    "height": 583
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a01b45-593c-7552-89eb-50c5ba292136.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a01b45-593c-7552-89eb-50c5ba292136",
    "storage_key": "property/6767906449167660/01a01b45-593c-7552-89eb-50c5ba292136.webp",
    "width": 1280,
    "height": 545
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162466/01a0b110-11a0-73bb-ba59-e09d0fa98a78.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162466/01a0105a-2d11-75c8-b1a7-2269011410e5.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162466/01a0b10f-c4d1-77d8-b6d1-8c4ee1490c37.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162466/01a0105a-2d11-75c8-b1a7-2269011410e5.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#070a0b",
  "property_secondary_color": "#78797e",
  "property_font_color": null,
  "property_color_4": "#f6ffff",
  "property_color_3": "#b4af2d",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "548 - 1155",
  "property_sqft_min": "456",
  "property_sqft_max": "1295",
  "property_price_range": "1337 - 2849",
  "property_price_min": "1334",
  "property_price_max": "2435",
  "property_available_units": 19,
  "property_facebook_url": "https://www.facebook.com/1221broadway/",
  "property_instagram_url": "https://www.instagram.com/1221broadway/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJyd9x5Pn1XIYR1XE5aKz0t0s",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to 1221 Broadway Lofts",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Home",
  "property_home_amenities_blurb": "<p><strong>Amenities with a Downtown point of view.</strong> Rise to the rooftop pool for skyline views, unwind by the garden-style courtyard pool, or spread out across five landscaped courtyards with BBQ areas. Inside, industrial loft details set the tone: 10'5\" ceilings, diamond-polished concrete floors, commercial-grade windows, and granite countertops. Add 24-hour cardio, open-air lifting and boxing, garage parking, EV charging, and package service for a connected 1221 Broadway experience.</p>",
  "property_home_floorplans_blurb": "<p><strong>Loft living with room to choose.</strong> Explore studio, one-, and two-bedroom layouts with high ceilings, diamond-polished concrete floors, granite countertops, and commercial-grade windows. Select homes add floor-to-ceiling glass, Juliette or extended balconies, skyline, Riverwalk, pool, or courtyard views, and street-access entries for a townhome-style touch.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview the loft life in full color.</strong> From a rooftop pool with downtown skyline views to a lush courtyard pool and open-air walkways, the gallery captures 1221 Broadway Lofts’ mix of concrete, glass, and greenery. Step inside for tall ceilings, polished concrete floors, granite-topped kitchens, and expansive commercial-grade windows—plus select lofts with floor-to-ceiling glass, balconies, or direct street access.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Broadway puts downtown within easy reach.</strong> From 1221 Broadway Lofts, follow the Museum Reach for river views and public art, wander to the San Antonio Museum of Art, or head toward Pearl for restaurants, markets, coffee, and courtyard energy. Closer to home, adaptive-reuse landmarks, local bars, bikeable streets, and quick transit connections keep the city easy to explore.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents say the essentials stand out.</strong> Reviews highlight responsive maintenance, communicative management, and a Downtown San Antonio location that’s “hard to beat.” Unique loft layouts, thick concrete walls, well-kept community spaces, and walkable city access all come up often—offering a grounded look at what daily life at 1221 Broadway Lofts feels like.</p>",
  "property_neighborhood_blurb": "<p><strong>Your Downtown map starts on Broadway.</strong> Step outside 1221 Broadway Lofts and you’re in the middle of San Antonio’s north-of-downtown culture corridor, where dinner plans, riverfront walks, and weekend browsing can happen without a big production. Follow the Museum Reach for public art and water views, wander toward San Antonio Museum of Art, or head up Broadway to Pearl for restaurants, markets, coffee, and courtyard energy.</p><p>Closer to home, the neighborhood mixes adaptive-reuse landmarks, local bars, bikeable streets, and quick transit connections with the skyline just south. After exploring the map, come back to loft living with rooftop views, courtyard spaces, and <a href=\"/amenities\">amenities</a> that keep the city feeling easy—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the location fits your day.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity spaces with real range.</strong> Start above it all at the rooftop pool, where skyline views make an easy backdrop for a quiet reset or a sunny afternoon. Closer to ground level, the courtyard pool trades city energy for greenery, flowers, and hanging plants, while five landscaped courtyards and BBQ areas give you more room to unwind outdoors.</p><p>Inside, the loft experience stays just as distinctive: 10'5\" ceilings, diamond-polished concrete floors, commercial-grade windows, and granite countertops create a clean industrial canvas. Select homes add floor-to-ceiling glass, Juliette or extended balconies, street-access entrances, and downtown or Riverwalk views. With 24-hour cardio, open-air Olympic lifting and boxing, garage parking, EV charging, and a package center, 1221 Broadway Lofts brings everyday convenience and standout design into one connected Downtown address. See more in the <a href=\"/gallery\">amenity gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Ready for loft living with Downtown energy?</strong> Start your application for 1221 Broadway Lofts and step closer to polished concrete floors, soaring ceilings, oversized windows, and distinct studio, one-, or two-bedroom layouts in an adaptive-reuse community on the Broadway corridor.</p>",
  "property_contactus_blurb": "<p><strong>Questions about 1221 Broadway Lofts?</strong> Reach out to the leasing team for details on studio, one-, and two-bedroom loft apartments, adaptive-reuse finishes, availability, or directions to our Broadway corridor address in Downtown San Antonio.</p>",
  "property_faqs_blurb": "<p><strong>Questions about 1221 Broadway Lofts?</strong> Start here for quick answers on leasing, loft-style living, community details, and everyday expectations. From <a href=\"/floor-plans\">floor plans</a> to <a href=\"/amenities\">amenities</a>, this FAQ is designed to help you move forward with confidence—and the leasing team is always happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the loft that fits your rhythm.</strong> At 1221 Broadway Lofts, floor plans range from streamlined studios to roomy one- and two-bedroom layouts, giving you options for an open live-sleep space, a separated bedroom, or extra room to spread out. Each home keeps the look crisp and urban with high ceilings, diamond-polished concrete floors, granite countertops, and commercial-grade windows that pull in natural light. As you compare availability, look for select plans with floor-to-ceiling windows, Juliette or extended balconies, downtown, Riverwalk, pool, or courtyard views, and street-access entrances for a more townhome-inspired feel. Browse the cards below to match your preferred layout, price point, and move-in timing—then choose the loft that feels right from the first look.</p>",
  "property_gallery_blurb": "<p><strong>See the loft from every angle.</strong> Browse the gallery for the moments that define 1221 Broadway Lofts: a rooftop pool framed by downtown skyline views, a courtyard pool softened by lush planting, and open-air walkways that turn concrete, glass, and greenery into part of the everyday backdrop.</p><p>Inside, the photos bring the details into focus—tall ceilings, polished concrete floors, granite-topped kitchens, and broad commercial-grade windows that brighten each space. Look for select homes with floor-to-ceiling glass, balconies, or direct street access as you compare studio, one-, and two-bedroom <a href=\"/floor-plans\">loft layouts</a>. Then explore more community spaces on the <a href=\"/amenities\">amenities</a> page, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the views, finishes, and courtyards in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore 1221 Broadway Lofts on the map.</strong> See available loft apartments, then zoom out to get a feel for the Broadway corridor—between Downtown, River North, Museum Reach, and Pearl—where dining, culture, and everyday conveniences sit close to home.</p>",
  "property_pets_blurb": "<p><strong>Room to roam, right at home.</strong> At 1221 Broadway Lofts, your pet-friendly routine is built into the community—not tacked on. Start with an on-site fenced dog park for off-leash breaks, then switch to courtyard strolls, elevator convenience, and easy cleanups at home with polished concrete floors and in-unit laundry. Cats get bright loft perches by oversized windows, while dogs get quick access to fresh air without leaving the property.</p><p>When you’re ready to stretch the route, leashed walks along the nearby River Walk trails make city living feel more walkable in San Antonio. Explore more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how 1221 Broadway Lofts fits life with your pet.</p>",
  "property_referafriend_blurb": "<p><strong>Share the loft life you love.</strong> From industrial character and oversized windows to courtyards, pools, and Downtown San Antonio energy, 1221 Broadway Lofts gives friends plenty to get excited about. Send a referral and invite them to find their own studio, one-, or two-bedroom loft here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at 1221 Broadway Lofts.</strong><br>Pay rent, submit maintenance requests, and manage your account from one convenient place—so you can get back to enjoying the industrial loft character, downtown energy, and distinctive spaces that make life on Broadway feel connected and easy.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents value most.</strong> In reviews for 1221 Broadway Lofts, recurring praise centers on responsive maintenance, communicative management, and a Downtown setting residents describe as hard to beat.</p><p>You’ll see residents call out helpful team members, unique loft layouts, thick concrete walls, well-kept community spaces, and the walkable access that gives daily life its city-energy feel. One resident sums it up simply: “the location can’t be beat.” Browse the reviews to get a grounded look at what living here is really like.</p>",
  "property_created_at": "1786657594863",
  "property_scheduletour_blurb": "<p><strong>See the loft character up close.</strong> Tour polished concrete floors, soaring ceilings, oversized commercial-grade windows, and the distinct layouts that define 1221 Broadway Lofts. Explore the <a href=\"/floor-plans\">studio, one-, and two-bedroom lofts</a>, then book your visit to experience the Downtown San Antonio energy in person.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we received your inquiry.</strong><br>The 1221 Broadway Lofts leasing team will be in touch soon. In the meantime, picture industrial loft character with polished concrete floors, soaring ceilings, oversized windows, and the energy of San Antonio’s Broadway corridor all close to home.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you schedule.</strong> The virtual tours at 1221 Broadway Lofts let you move through select studio and one-bedroom layouts, comparing open loft proportions, concrete-and-window character, kitchen flow, bedroom separation, closet placement, and the natural light that makes each home feel different.</p><p>Then explore the community spaces available in 3D: the open-air Olympic lifting and boxing gym and the landscaped courtyard pool. Use the tours to narrow your favorite apartment layout, see how the amenity spaces fit your day, and decide what you want to view next in person. When you’re ready, compare current <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to keep the search moving.</p>",
  "property_copyright": "2026 All Rights Reserved. 1221 Broadway Lofts",
  "property_seo_title_home": "1221 Broadway Lofts | Apartments Near Downtown San Antonio",
  "property_seo_description_home": "Experience urban living at 1221 Broadway Lofts in San Antonio! Enjoy studio, 1, & 2-bedroom floor plans, luxurious amenities, & more. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Apartments Near the Pearl San Antonio",
  "property_seo_description_floorplans": "Find your ideal space at 1221 Broadway Lofts in San Antonio, TX. Choose from stylish studios to spacious two-bedrooms. Your perfect floor plan awaits!",
  "property_seo_title_amenities": "Amenities | Pet Friendly Apartments San Antonio",
  "property_seo_description_amenities": "Elevate your lifestyle at 1221 Broadway Lofts in San Antonio with amenities like a rooftop swimming pool, clubhouse, 24-hour fitness center, dog park, & more!",
  "property_seo_title_gallery": "Gallery | Pearl District San Antonio Apartments",
  "property_seo_description_gallery": "Picture life at 1221 Broadway Lofts! Stunning pools, lush courtyards, and modern interiors await you in San Antonio. Your dream home is just a click away!",
  "property_seo_title_virtualtours": "Virtual Tours | Luxury Apartments San Antonio Texas",
  "property_seo_description_virtualtours": "Experience urban elegance at 1221 Broadway Lofts in San Antonio, TX. Take a virtual tour of our stylish studios and spacious 1-2 bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | 1221 Broadway Lofts Apartments",
  "property_seo_description_interactivemap": "Experience urban living at 1221 Broadway Lofts! Choose from chic studios to spacious two-bedrooms with luxury amenities and stunning San Antonio views.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in the Pearl District San Antonio",
  "property_seo_description_neighborhood": "Uncover San Antonio's vibrant charm around 1221 Broadway Lofts. Enjoy living near Downtown San Antonio, The Pearl, San Antonio River, and more.",
  "property_seo_title_contact": "Contact Us | San Antonio Luxury Apartments",
  "property_seo_description_contact": "Reach out to the friendly leasing team at 1221 Broadway Lofts in San Antonio, TX. Inquire about our studios, one and two-bedroom layouts today!",
  "property_seo_title_faqs": "FAQs | Apartments in San Antonio, TX",
  "property_seo_description_faqs": "Discover answers at 1221 Broadway Lofts, San Antonio. Explore unique amenities and floor plans for your perfect living experience!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in San Antonio, TX",
  "property_seo_description_reviews": "Experience 1221 Broadway Lofts in San Antonio! Enjoy skyline views, vibrant amenities, and a welcoming community—our residents love calling us home!",
  "property_seo_title_applynow": "Apply Now | Apartments Near the Pearl San Antonio",
  "property_seo_description_applynow": "Discover urban elegance at 1221 Broadway Lofts in San Antonio. Enjoy stunning views, a rooftop pool, fitness amenities, and stylish layouts. Lease online!",
  "property_seo_title_residentaccess": "Resident Access | Modern Apartments in San Antonio",
  "property_seo_description_residentaccess": "Login to your 1221 Broadway Lofts resident portal in San Antonio, TX. Manage rent, schedule maintenance, and connect with your community effortlessly!",
  "property_seo_title_referafriend": "Refer A Friend | 1221 Broadway Lofts",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to 1221 Broadway Lofts in San Antonio and enjoy exclusive perks together in our vibrant community.",
  "property_seo_title_scheduletour": "Schedule a Tour | Apartments Near Downtown San Antonio",
  "property_seo_description_scheduletour": "Experience urban elegance at 1221 Broadway Lofts in San Antonio. Schedule a tour today and see why our vibrant community feels like home!",
  "property_seo_title_privacy": "Privacy Policy | 1221 Broadway Lofts",
  "property_seo_description_privacy": "Safeguarding your peace of mind at 1221 Broadway Lofts. Read our privacy policy to understand how we protect your personal information in San Antonio, TX.",
  "property_seo_title_accessibility": "Website Accessibility | 1221 Broadway Lofts",
  "property_seo_description_accessibility": "At 1221 Broadway Lofts in San Antonio, we prioritize accessibility for all. Join our commitment to digital inclusion and experience community living redefined!",
  "property_seo_title_sitemap": "Sitemap | 1221 Broadway Lofts",
  "property_seo_description_sitemap": "Uncover the unique charm of 1221 Broadway Lofts in San Antonio. Navigate our sitemap for a seamless journey to your future home today!",
  "property_seo_title_thankyou": "Thank You | 1221 Broadway Lofts",
  "property_seo_description_thankyou": "Thank you for reaching out to 1221 Broadway Lofts in San Antonio! Our team will connect with you soon to help you find your dream home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in San Antonio Pet Friendly",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793745426630",
  "amenities": [
    {
      "id": "ec_f8ae071bfa630c47160c9c0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188733",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9b81fb8748bf6cb09d8e7ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188734",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2522713db4b3375e61557ec6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188735",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5d492809f120ebf61136c4ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128488999",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8dd1864f9d3d023b23959522",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188702",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6f40d79d0a540922a606953a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188698",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_201b943a03e1d63a18045275",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954551",
      "title": "Controlled Access Gates",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b06924285a25c77f8e4293cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954552",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd18-5def-77ec-a2bd-1b36d87e99e5.webp",
      "amenity_image_media": {
        "alt_text": "Built-in outdoor gas grills with stainless steel lids and cabinetry.",
        "public_id": "019ffd18-5def-77ec-a2bd-1b36d87e99e5",
        "storage_key": "property/6767906449167660/019ffd18-5def-77ec-a2bd-1b36d87e99e5.webp",
        "width": 2458,
        "height": 1707
      },
      "amenity_image_alt_text": "Outdoor grilling area with built in barbecue stations at 1221 Broadway Lofts Apartments, Texas, 78215",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7aedadd326c7da2954447955",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954554",
      "title": "24 Hour Fitness Cardio Gym",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd18-5ad3-72ea-8b36-a30fc5fbb428.webp",
      "amenity_image_media": {
        "alt_text": "Treadmills, elliptical, rowing machine, and free weights in a modern apartment fitness center.",
        "public_id": "019ffd18-5ad3-72ea-8b36-a30fc5fbb428",
        "storage_key": "property/6767906449167660/019ffd18-5ad3-72ea-8b36-a30fc5fbb428.webp",
        "width": 2560,
        "height": 1792
      },
      "amenity_image_alt_text": "Fitness center with cardio equipment and training area at 1221 Broadway Lofts Apartments, Texas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ab53157bfc69e4650a4d2ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954555",
      "title": "Parking Garage (reserved spots available)",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd18-4e0d-72cd-8d7f-bdb9282040ec.webp",
      "amenity_image_media": {
        "alt_text": "Interior view of a modern apartment with large windows showcasing a city skyline and lush greenery.",
        "public_id": "019ffd18-4e0d-72cd-8d7f-bdb9282040ec",
        "storage_key": "property/6767906449167660/019ffd18-4e0d-72cd-8d7f-bdb9282040ec.webp",
        "width": 1194,
        "height": 1536
      },
      "amenity_image_alt_text": "Loft interior with city skyline views and private balcony at 1221 Broadway Lofts Apartments, San Antonio, TX 78215",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_910042cee41e48df59db3359",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954558",
      "title": "Roof Top Pool with Free Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd18-5e07-708f-b7e1-9141db53da29.webp",
      "amenity_image_media": {
        "alt_text": "Modern swimming pool with lounge chairs on a rooftop deck.",
        "public_id": "019ffd18-5e07-708f-b7e1-9141db53da29",
        "storage_key": "property/6767906449167660/019ffd18-5e07-708f-b7e1-9141db53da29.webp",
        "width": 2560,
        "height": 1596
      },
      "amenity_image_alt_text": "Rooftop pool with colorful lounge chairs at 1221 Broadway Lofts Apartments, San Antonio, Texas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_36ffde9b70c448f333d7291b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954568",
      "title": "24 Hour Package Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_96305118840a8bf322ca8298",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188699",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5fe88a8909daa2e28c219d74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188712",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b89eb20884691fefee539a77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188713",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04f229bf67001137709f0a6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188714",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5ef12a8d15c8534c83c24a62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188715",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_98435ef0b648801838ae5e1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188716",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b46a1cf38a662ac51686758",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188717",
      "title": "View",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d24ecee7ec6cd3c839e6090",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188718",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc23718304b5256d7cdab2b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188721",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_511fbdd5da21ce5c930e46d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188706",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4db37496a5683995caf032ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188707",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_afbe917c6f5c20b39bf1ba9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188708",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3024302d28b87e591febff91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188709",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fffa706687e38b4874e95946",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188710",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21be4bcfaea3ab9bd2a61967",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188704",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ae7c0bbe2fb03e65b6bd8beb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188705",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5051094ba4f1b6717c4e1063",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954548",
      "title": "Run Club",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8bd8d48661fc44b99471c14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954550",
      "title": "Short Term Leases Offered",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c0b0f9190e86474756ae462",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954553",
      "title": "Courtyards with Greenery and Flowered Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd18-4f17-759c-b11a-a89b57756813.webp",
      "amenity_image_media": {
        "alt_text": "Courtyard with a large water tank, seating area, and landscaping.",
        "public_id": "019ffd18-4f17-759c-b11a-a89b57756813",
        "storage_key": "property/6767906449167660/019ffd18-4f17-759c-b11a-a89b57756813.webp",
        "width": 2464,
        "height": 1707
      },
      "amenity_image_alt_text": "Courtyard with native landscaping and seating area at 1221 Broadway Lofts Apartments, San Antonio, TX",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b80d58b39b84b466c81b9430",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954557",
      "title": "Designated Package Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_07bfb98ff16bdbb27985a4ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954559",
      "title": "Pet Friendly with Fenced-In Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e89819690cec6877990d9d91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954560",
      "title": "Within Walking Distance to the Bus Line",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7ba234331d26b0545fab0123",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954561",
      "title": "Museum Reach of the San Antonio Riverwalk",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_755ff3d81c31d48d2610807d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954569",
      "title": "Door to Door Valet Trash Service",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_84a2e94d340eec8936b766ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954562",
      "title": "Landscaped Courtyard Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eaed3013d67c5562ab3b0f20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954570",
      "title": "Four Elevators Throughout the Property",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_58ebfa379f14cac1f837b4a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954563",
      "title": "Resident Lounge with Wireless Sound System",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7208da85dd212a7949bc393d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954564",
      "title": "24 Hour Open-air Olympic Lifting and Boxing Gym",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_456bef1d54a1170a795482bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954571",
      "title": "Juliette and Extended Balconies (in select units)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd18-4e0d-72cd-8d7f-bdb9282040ec.webp",
      "amenity_image_media": {
        "alt_text": "Interior view of a modern apartment with large windows showcasing a city skyline and lush greenery.",
        "public_id": "019ffd18-4e0d-72cd-8d7f-bdb9282040ec",
        "storage_key": "property/6767906449167660/019ffd18-4e0d-72cd-8d7f-bdb9282040ec.webp",
        "width": 1194,
        "height": 1536
      },
      "amenity_image_alt_text": "Loft interior with city skyline views and private balcony at 1221 Broadway Lofts Apartments, San Antonio, TX 78215",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_68838569608ff5cc11907763",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954565",
      "title": "10 Minute Walk to the Historic Pearl Brewery",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_61e96223fd60c5eb0374b867",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954572",
      "title": "10'5\\\" Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee7fa4d948956a7230fbb6f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954573",
      "title": "Downtown and Riverwalk Views (on select units)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1617b678ff0c6725137f7318",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954567",
      "title": "EV Charging Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_78e921f2a82fbc1727d4c91d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954574",
      "title": "Diamond Polished Concrete Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_747b48063e190ad7ed4d18d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954575",
      "title": "Commercial Grade Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5adca1f3da71acc22028ebd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188737",
      "title": "EV Charging",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc03ad618415a23ef76dbaa6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954576",
      "title": "Pool and Courtyard Views (in select units)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd18-4eb9-769b-aacf-b1d66f9cce14.webp",
      "amenity_image_media": {
        "alt_text": "Apartment building courtyard with a large swimming pool and lounge chairs.",
        "public_id": "019ffd18-4eb9-769b-aacf-b1d66f9cce14",
        "storage_key": "property/6767906449167660/019ffd18-4eb9-769b-aacf-b1d66f9cce14.webp",
        "width": 2560,
        "height": 1597
      },
      "amenity_image_alt_text": "Resort style pool with waterfall feature at 1221 Broadway Lofts Apartments, San Antonio",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1799422f5410d5f5aa7abd0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954577",
      "title": "Floor to Ceiling Windows (in select units)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea3d3c7984a9381d781be9c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188741",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_213b2bb047703d09c0402549",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188757",
      "title": "City",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f265cf5d2267020ba8d246b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954578",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4508d0ca3f8fa3ac40f57daa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188769",
      "title": "Online Maintenance Portal",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9f3e25fe3998613cd55d301",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "124954579",
      "title": "Street Access Entrances (in select units)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6f982431777746c13dcceab8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188722",
      "title": "In Unit Laundry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c289d1e2c96ec74aa02e074",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "128188778",
      "title": "Rooftop Deck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_1646b327af3698cc38b5099e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025df-49bb-725b-b2ab-bd037071e700.webp",
      "image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city skyline view.",
        "public_id": "01a025df-49bb-725b-b2ab-bd037071e700",
        "storage_key": "property/6767906449167660/01a025df-49bb-725b-b2ab-bd037071e700.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our rooftop swimming pool, complete with comfortable lounge chairs and stunning city views.",
      "link": "false",
      "alt_text": "Rooftop pool with lounge chairs and pergola at 1221 Broadway Lofts Apartments, San Antonio, TX 78215",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/broadway%20lofts-poi-014.jpg"
    },
    {
      "id": "ec_63819ee2f7ad22c67c2ecb8a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a060c9-7d81-7758-954b-b565e0fa5e7f.webp",
      "image_media": {
        "alt_text": "Rooftop swimming pool with city skyline at dusk.",
        "public_id": "01a060c9-7d81-7758-954b-b565e0fa5e7f",
        "storage_key": "property/6767906449167660/01a060c9-7d81-7758-954b-b565e0fa5e7f.webp",
        "width": 320,
        "height": 403
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our rooftop pool, complete with stunning city views. Perfect for relaxing or socializing.",
      "link": "false",
      "alt_text": "A pool with a slide and people in it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/rooftop%20pool%204.jpg"
    },
    {
      "id": "ec_fd3ae618abd414ceefe2107c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025df-7751-717c-8e09-d95801ffd60b.webp",
      "image_media": {
        "alt_text": "Woman in red shirt and denim shorts standing on a balcony overlooking trees and buildings.",
        "public_id": "01a025df-7751-717c-8e09-d95801ffd60b",
        "storage_key": "property/6767906449167660/01a025df-7751-717c-8e09-d95801ffd60b.webp",
        "width": 1849,
        "height": 2560
      },
      "title": "Apartment",
      "description": "Enjoy modern living with exposed concrete ceilings and a private balcony, perfect for city views and fresh air. This apartment features comfortable seating and ample natural light.",
      "link": "false",
      "alt_text": "Industrial loft interior with exposed concrete ceiling at 1221 Broadway Lofts Apartments, San Antonio, TX",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/1221%208_11_25-14.jpg"
    },
    {
      "id": "ec_ad71564cf2c5c95bfb8e8544",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025df-ff97-700d-a8a3-c394945db7c6.webp",
      "image_media": {
        "alt_text": "Modern seating area with striped cushions and a geometric rug, next to large glass doors.",
        "public_id": "01a025df-ff97-700d-a8a3-c394945db7c6",
        "storage_key": "property/6767906449167660/01a025df-ff97-700d-a8a3-c394945db7c6.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish communal lounge, featuring comfortable seating and a vibrant atmosphere.",
      "link": "false",
      "alt_text": "Lobby lounge with striped seating and floral wallpaper at 1221 Broadway Lofts Apartments, Texas, 78215",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/broadway%20lofts-poi-013.jpg"
    },
    {
      "id": "ec_fb494c447f9d520923b7d4d1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025df-85c5-7679-8068-703b193ea6da.webp",
      "image_media": {
        "alt_text": "Loft-style apartment interior with exposed concrete walls, open living space, and modern kitchen.",
        "public_id": "01a025df-85c5-7679-8068-703b193ea6da",
        "storage_key": "property/6767906449167660/01a025df-85c5-7679-8068-703b193ea6da.webp",
        "width": 2560,
        "height": 1708
      },
      "title": "Apartment",
      "description": "Experience urban living in this stylish loft apartment featuring industrial-chic exposed concrete, a spacious open-plan living area, and a sleek, modern kitchen.",
      "link": "false",
      "alt_text": "Open concept living space with exposed concrete at 1221 Broadway Lofts Apartments, San Antonio, TX 78215",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/1221%208_11_25-12.jpg"
    },
    {
      "id": "ec_062cadaf9c4f6c4999fb2259",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025e0-258a-707c-a46b-caad8b3967f2.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and an umbrella-covered dining table.",
        "public_id": "01a025e0-258a-707c-a46b-caad8b3967f2",
        "storage_key": "property/6767906449167660/01a025e0-258a-707c-a46b-caad8b3967f2.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool, complete with comfortable lounge chairs and a shaded dining area, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Pool deck with dining area and umbrella at 1221 Broadway Lofts Apartments, San Antonio, 78215",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/broadway%20lofts-poi-009.jpg"
    },
    {
      "id": "ec_ffa4c67f2cfa26ccb0413f5c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025df-7a71-70bc-8e76-7eb01ae77f65.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, light wood cabinets, and a concrete floor.",
        "public_id": "01a025df-7a71-70bc-8e76-7eb01ae77f65",
        "storage_key": "property/6767906449167660/01a025df-7a71-70bc-8e76-7eb01ae77f65.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "A sleek and modern kitchen featuring stainless steel appliances, ample cabinet space, and a stylish island with bar stools, perfect for a contemporary living space.",
      "link": "false",
      "alt_text": "Open kitchen with island seating and industrial details at 1221 Broadway Lofts Apartments, San Antonio",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/broadway%20lofts-poi-004.jpg"
    },
    {
      "id": "ec_1cce336200022911ae90d480",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025df-f217-75a0-9a50-80549b658580.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge seating and building balconies.",
        "public_id": "01a025df-f217-75a0-9a50-80549b658580",
        "storage_key": "property/6767906449167660/01a025df-f217-75a0-9a50-80549b658580.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool, surrounded by lush landscaping and modern architecture. Perfect for relaxing and unwinding.",
      "link": "false",
      "alt_text": "Resort style swimming pool with tropical landscaping at 1221 Broadway Lofts Apartments, San Antonio, Texas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/broadway%20lofts-poi-010.jpg"
    },
    {
      "id": "ec_130d491ecf816fbad2e7230e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025df-7945-77bd-a708-87328c0e857c.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a couch, dining table, and modern appliances.",
        "public_id": "01a025df-7945-77bd-a708-87328c0e857c",
        "storage_key": "property/6767906449167660/01a025df-7945-77bd-a708-87328c0e857c.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Modern apartment living area with an open-concept kitchen featuring stainless steel appliances, a dining table, and a comfortable living room space.",
      "link": "false",
      "alt_text": "Open concept loft with industrial design features at 1221 Broadway Lofts Apartments, San Antonio, TX 78215",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/broadway%20lofts-poi-007.jpg"
    },
    {
      "id": "ec_f0ebf85c8fb78b440d72f85f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025df-744f-70ac-a16c-756315abde41.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "01a025df-744f-70ac-a16c-756315abde41",
        "storage_key": "property/6767906449167660/01a025df-744f-70ac-a16c-756315abde41.webp",
        "width": 2560,
        "height": 1711
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring dark wood cabinetry, a stainless steel refrigerator, microwave, and oven, complemented by granite countertops and a subway tile backsplash.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops and dark wood cabinets at 1221 Broadway Lofts Apartments, Texas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/1221%208_11_25-10.jpg"
    },
    {
      "id": "ec_71e6b8b9391199e5b6473dc7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025df-a5c1-766d-9e52-3124b4d99d23.webp",
      "image_media": {
        "alt_text": "Modern living room with sofa, armchair, bookshelves, and abstract art.",
        "public_id": "01a025df-a5c1-766d-9e52-3124b4d99d23",
        "storage_key": "property/6767906449167660/01a025df-a5c1-766d-9e52-3124b4d99d23.webp",
        "width": 2560,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Step into this stylish living area, perfect for relaxing or entertaining. Features comfortable seating, ample storage, and unique wall art.",
      "link": "false",
      "alt_text": "Modern living room with contemporary artwork at 1221 Broadway Lofts Apartments, San Antonio, TX",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/1221%208_11_25-01.jpg"
    },
    {
      "id": "ec_8d47856fe8abef53da294ee2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025df-afad-7296-aa4a-3d7cf6311d25.webp",
      "image_media": {
        "alt_text": "Bedroom with concrete walls and ceiling, featuring a queen-size bed with white patterned comforter and decorative pillows.",
        "public_id": "01a025df-afad-7296-aa4a-3d7cf6311d25",
        "storage_key": "property/6767906449167660/01a025df-afad-7296-aa4a-3d7cf6311d25.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Apartment",
      "description": "Spacious bedroom with a queen-size bed, industrial-style decor, and ample storage. Enjoy a comfortable and stylish living space.",
      "link": "false",
      "alt_text": "Industrial loft bedroom with exposed concrete walls at 1221 Broadway Lofts Apartments, Texas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/broadway%20lofts-poi-005.jpg"
    },
    {
      "id": "ec_331e4f3994adaa0f6551a827",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025df-b124-71ae-a494-b0cc11f36a75.webp",
      "image_media": {
        "alt_text": "Living room with two white armchairs, a beige sofa, and a glass coffee table.",
        "public_id": "01a025df-b124-71ae-a494-b0cc11f36a75",
        "storage_key": "property/6767906449167660/01a025df-b124-71ae-a494-b0cc11f36a75.webp",
        "width": 2560,
        "height": 1711
      },
      "title": "Apartment",
      "description": "Stylish living room with modern furnishings, including a comfortable sofa and armchairs, perfect for relaxing.",
      "link": "false",
      "alt_text": "Modern living room with industrial style ceiling at 1221 Broadway Lofts Apartments, San Antonio, Texas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/1221%208_11_25-08.jpg"
    },
    {
      "id": "ec_edc9f82789821be98627fb3b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025df-b242-75ba-bc76-0c1494a16a29.webp",
      "image_media": {
        "alt_text": "Stylish living room with a beige sofa, two white armchairs, a glass coffee table, and a large window with a view.",
        "public_id": "01a025df-b242-75ba-bc76-0c1494a16a29",
        "storage_key": "property/6767906449167660/01a025df-b242-75ba-bc76-0c1494a16a29.webp",
        "width": 2560,
        "height": 1711
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed living space, featuring comfortable seating and ample natural light. Enjoy the city views from your modern apartment.",
      "link": "false",
      "alt_text": "Modern living room with floor to ceiling windows at 1221 Broadway Lofts Apartments, San Antonio",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/1221%208_11_25-09.jpg"
    },
    {
      "id": "ec_d9424e6450bae32c15a0c9ec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025df-bdef-735c-8bf0-3bb8987e5de0.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower/tub combo.",
        "public_id": "01a025df-bdef-735c-8bf0-3bb8987e5de0",
        "storage_key": "property/6767906449167660/01a025df-bdef-735c-8bf0-3bb8987e5de0.webp",
        "width": 3072,
        "height": 2054
      },
      "title": "Apartment",
      "description": "Bright and clean apartment bathroom featuring a wooden vanity, toilet, and a shower/tub combination with a white curtain.",
      "link": "false",
      "alt_text": "Bathroom with white vanity and bathtub at 1221 Broadway Lofts Apartments, Texas, 78215",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/broadway%20lofts-poi-006.jpg"
    },
    {
      "id": "ec_b464058024637b78c074ce3c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025e0-069c-765f-bcc4-3e9d060fa8c1.webp",
      "image_media": {
        "alt_text": "Outdoor dining area with a long communal table and chairs.",
        "public_id": "01a025e0-069c-765f-bcc4-3e9d060fa8c1",
        "storage_key": "property/6767906449167660/01a025e0-069c-765f-bcc4-3e9d060fa8c1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy al fresco dining in our communal outdoor space, perfect for gatherings with friends and neighbors.",
      "link": "false",
      "alt_text": "Community outdoor dining area with long table at 1221 Broadway Lofts Apartments, San Antonio",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/broadway%20lofts-poi-011.jpg"
    },
    {
      "id": "ec_5ac8092697a17f0d1dd693a2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025df-f825-72c8-81c4-49918060a09c.webp",
      "image_media": {
        "alt_text": "Gym with free weights, punching bags, and rowing machine.",
        "public_id": "01a025df-f825-72c8-81c4-49918060a09c",
        "storage_key": "property/6767906449167660/01a025df-f825-72c8-81c4-49918060a09c.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Fully equipped fitness center with cardio machines, weightlifting equipment, and boxing gear for resident use.",
      "link": "false",
      "alt_text": "Fitness center with boxing equipment and free weights at 1221 Broadway Lofts Apartments, San Antonio, TX",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/broadway%20lofts-poi-008.jpg"
    },
    {
      "id": "ec_dc1fcf992da0935d056d5463",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025e0-446b-73ad-8416-b936de9870aa.webp",
      "image_media": {
        "alt_text": "Community lounge area with kitchen, seating, and tables.",
        "public_id": "01a025e0-446b-73ad-8416-b936de9870aa",
        "storage_key": "property/6767906449167660/01a025e0-446b-73ad-8416-b936de9870aa.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Modern community lounge area featuring a sleek kitchen with neon \"get off your phone\" sign, dining tables, and comfortable seating, perfect for residents to gather and relax.",
      "link": "false",
      "alt_text": "Community kitchen with industrial pendant lighting at 1221 Broadway Lofts Apartments, Texas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/broadway%20lofts-poi-012.jpg"
    },
    {
      "id": "ec_e87a97aff3b1bd752572f8ba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025e0-49ca-7598-ad6b-90a508fa2931.webp",
      "image_media": {
        "alt_text": "Modern co-working space with rustic and industrial accents.",
        "public_id": "01a025e0-49ca-7598-ad6b-90a508fa2931",
        "storage_key": "property/6767906449167660/01a025e0-49ca-7598-ad6b-90a508fa2931.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Discover a stylish co-working space designed for productivity and collaboration. Features include a sleek kitchenette, comfortable lounge areas, and a modern workspace.",
      "link": "false",
      "alt_text": "Stylish lounge area with creative workspace at 1221 Broadway Lofts Apartments, San Antonio, 78215",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/broadway%20lofts-poi-001.jpg"
    },
    {
      "id": "ec_926dca5a4cff1eb4816147b8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025e0-613f-728a-9cf4-8fb4caa52afc.webp",
      "image_media": {
        "alt_text": "Entrance to the leasing office with a modern swing bench outside.",
        "public_id": "01a025e0-613f-728a-9cf4-8fb4caa52afc",
        "storage_key": "property/6767906449167660/01a025e0-613f-728a-9cf4-8fb4caa52afc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to the leasing office, featuring a unique outdoor swing bench and lush landscaping, creating an inviting atmosphere.",
      "link": "false",
      "alt_text": "Outdoor courtyard with suspended swing and planters at 1221 Broadway Lofts Apartments, San Antonio, Texas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/broadway%20lofts-poi-003.jpg"
    },
    {
      "id": "ec_ad85ebc4e25b1d8891c1a40e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025e0-7d68-7068-a1a7-dff029f36747.webp",
      "image_media": {
        "alt_text": "Courtyard with a large water tank and a small fountain surrounded by greenery and apartment buildings.",
        "public_id": "01a025e0-7d68-7068-a1a7-dff029f36747",
        "storage_key": "property/6767906449167660/01a025e0-7d68-7068-a1a7-dff029f36747.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the unique courtyard featuring a rustic water tank and a charming fountain, surrounded by lush greenery and modern apartment buildings.",
      "link": "false",
      "alt_text": "Courtyard with water feature and gravel landscaping at 1221 Broadway Lofts Apartments, San Antonio, TX",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/broadway%20lofts-poi-016.jpg"
    },
    {
      "id": "ec_b31618951c44b5c66d5dd4d1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025e0-5775-712c-9b7c-8ca002d29baa.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with colorful doors and a person sitting on a bench.",
        "public_id": "01a025e0-5775-712c-9b7c-8ca002d29baa",
        "storage_key": "property/6767906449167660/01a025e0-5775-712c-9b7c-8ca002d29baa.webp",
        "width": 1708,
        "height": 2560
      },
      "title": "Community",
      "description": "Experience urban living in this contemporary apartment complex, featuring vibrant exterior details and serene communal spaces perfect for relaxation.",
      "link": "false",
      "alt_text": "Courtyard with walking path and resident seating at 1221 Broadway Lofts Apartments, Texas, 78215",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/1221%208_11_25-11.jpg"
    },
    {
      "id": "ec_85fdf1a4e431031b572e04a5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a025e0-619f-77dd-9f0c-ec2ed029ca86.webp",
      "image_media": {
        "alt_text": "Modern apartment complex with a skybridge connecting buildings, a cyclist, and parked cars.",
        "public_id": "01a025e0-619f-77dd-9f0c-ec2ed029ca86",
        "storage_key": "property/6767906449167660/01a025e0-619f-77dd-9f0c-ec2ed029ca86.webp",
        "width": 2057,
        "height": 2560
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment building complex, showcasing a unique skybridge connecting towers, with residents enjoying the outdoor space and amenities. ",
      "link": "false",
      "alt_text": "Modern pedestrian bridge connecting residential buildings at 1221 Broadway Lofts Apartments, San Antonio, 78215",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/1221%208_11_25-07.jpg"
    },
    {
      "id": "ec_174906faa0c505c7e7587c73",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a060c9-80b9-712b-af78-b498ca96cd93.webp",
      "image_media": {
        "alt_text": "Exterior courtyard with green grass and mature trees, apartment buildings with balconies visible.",
        "public_id": "01a060c9-80b9-712b-af78-b498ca96cd93",
        "storage_key": "property/6767906449167660/01a060c9-80b9-712b-af78-b498ca96cd93.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the lush green courtyard at our community, surrounded by mature trees and apartment buildings featuring private balconies.",
      "link": "false",
      "alt_text": "A grassy area in front of apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Broadway%20Lofts-poi-019.jpg"
    },
    {
      "id": "ec_de1436e1c7b78fcb5e18398a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a060c9-8051-77f5-92aa-3a95cf52b414.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with a hanging bench in front of the leasing office.",
        "public_id": "01a060c9-8051-77f5-92aa-3a95cf52b414",
        "storage_key": "property/6767906449167660/01a060c9-8051-77f5-92aa-3a95cf52b414.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our modern apartment community. Enjoy the stylish exterior design and comfortable outdoor seating areas, including this unique hanging bench.",
      "link": "false",
      "alt_text": "A modern building with a glass entrance and a tree in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Broadway%20Lofts-poi-003(1).jpg"
    },
    {
      "id": "ec_738add6a79c3418a9c1dcc50",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a060c9-8111-77f8-91b3-d2c24157b078.webp",
      "image_media": {
        "alt_text": "Interior of a modern apartment complex gym with treadmills, elliptical machines, a rower, and free weights.",
        "public_id": "01a060c9-8111-77f8-91b3-d2c24157b078",
        "storage_key": "property/6767906449167660/01a060c9-8111-77f8-91b3-d2c24157b078.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Stay active and energized in our fully-equipped fitness center. Featuring state-of-the-art cardio machines and free weights, it's the perfect place to achieve your wellness goals.",
      "link": "false",
      "alt_text": "A gym with treadmills, exercise bikes, and weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Broadway%20Lofts-poi-015.jpg"
    },
    {
      "id": "ec_d32e1dc1b8e5d4e74ec30ff7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a060c9-7cd2-71f9-899b-0da6a2d7e3d1.webp",
      "image_media": {
        "alt_text": "Modern apartment building overlooking a river with a boat and a cyclist.",
        "public_id": "01a060c9-7cd2-71f9-899b-0da6a2d7e3d1",
        "storage_key": "property/6767906449167660/01a060c9-7cd2-71f9-899b-0da6a2d7e3d1.webp",
        "width": 2000,
        "height": 1613
      },
      "title": "Community",
      "description": "Experience urban living at its finest in this modern apartment building, situated along a scenic riverfront with vibrant community spaces and easy access to outdoor recreation.",
      "link": "false",
      "alt_text": "A modern building is situated next to a river with a bridge crossing over it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/26028_N9_medium.jpg"
    },
    {
      "id": "ec_ef22c9b6547c520a46c3d22c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a060c9-95c6-7352-a64b-d3fab5807a87.webp",
      "image_media": {
        "alt_text": "Yoga class on a rooftop at sunset",
        "public_id": "01a060c9-95c6-7352-a64b-d3fab5807a87",
        "storage_key": "property/6767906449167660/01a060c9-95c6-7352-a64b-d3fab5807a87.webp",
        "width": 1200,
        "height": 795
      },
      "title": "Lifestyle",
      "description": "Enjoy a relaxing yoga class with a view of the city skyline at sunset. A perfect way to unwind and stay active.",
      "link": "false",
      "alt_text": "A group of people practicing yoga on a rooftop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/garage%205.jpg"
    },
    {
      "id": "ec_0ca933b8590b0772731abad6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a060c9-9a1c-7770-b412-f0f9e1adbddb.webp",
      "image_media": {
        "alt_text": "Courtyard with seating and modern apartment buildings with balconies and outdoor stairs.",
        "public_id": "01a060c9-9a1c-7770-b412-f0f9e1adbddb",
        "storage_key": "property/6767906449167660/01a060c9-9a1c-7770-b412-f0f9e1adbddb.webp",
        "width": 402,
        "height": 403
      },
      "title": "Community",
      "description": "Enjoy the modern courtyard living at this apartment complex, complete with outdoor seating areas and architecturally striking buildings.",
      "link": "false",
      "alt_text": "A modern building with a courtyard surrounded by trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Grill%20Courtyard.jpg"
    },
    {
      "id": "ec_23122393397b2f599137f340",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a060c9-a312-7698-8e29-73a9552937dc.webp",
      "image_media": {
        "alt_text": "Modern blue apartment building exterior with balconies and large windows.",
        "public_id": "01a060c9-a312-7698-8e29-73a9552937dc",
        "storage_key": "property/6767906449167660/01a060c9-a312-7698-8e29-73a9552937dc.webp",
        "width": 316,
        "height": 402
      },
      "title": "Community",
      "description": "Exterior view of a stylish apartment building featuring balconies, large glass windows, and a modern blue facade, surrounded by lush greenery.",
      "link": "false",
      "alt_text": "A modern apartment building with balconies and solar panels on the roof.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Building%2018.jpg"
    },
    {
      "id": "ec_eefdef169f8f297a087912f0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a060c9-a69e-7160-91c2-80960e88f967.webp",
      "image_media": {
        "alt_text": "People doing yoga outdoors on a rooftop under a covered patio.",
        "public_id": "01a060c9-a69e-7160-91c2-80960e88f967",
        "storage_key": "property/6767906449167660/01a060c9-a69e-7160-91c2-80960e88f967.webp",
        "width": 1080,
        "height": 715
      },
      "title": "Lifestyle",
      "description": "Enjoy an invigorating yoga session on our rooftop, offering stunning city views and a refreshing outdoor atmosphere.",
      "link": "false",
      "alt_text": "A group of people doing yoga in a covered outdoor area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/garage%204.jpg"
    },
    {
      "id": "ec_5f01e9de2f0f88c9c64a8d2a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/01a060c9-aa12-7369-a122-95d0cc57e8b7.webp",
      "image_media": {
        "alt_text": "Modern apartment complex with a skybridge connecting buildings, showing balconies, parked cars, and a cyclist.",
        "public_id": "01a060c9-aa12-7369-a122-95d0cc57e8b7",
        "storage_key": "property/6767906449167660/01a060c9-aa12-7369-a122-95d0cc57e8b7.webp",
        "width": 323,
        "height": 402
      },
      "title": "Community",
      "description": "Experience contemporary living in this vibrant community, featuring unique architecture with a connecting skybridge, lush landscaping, and convenient parking.",
      "link": "false",
      "alt_text": "A man rides his bicycle down a sidewalk in front of a large building with a red metal structure.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Ave%20B.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_cb9bb48a-4da5-4cdf-9ccb-53d85c8d5122",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "The Esquire Tavern",
      "poi_type": "Restaurants",
      "poi_address": "155 E Commerce St, San Antonio, TX 78205, USA",
      "poi_short_description": "Inspired drinks & pub grub in vintage digs with a patio & the longest wooden bartop in Texas.",
      "poi_long_description": "Inspired drinks & pub grub in vintage digs with a patio & the longest wooden bartop in Texas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-d1e0-7679-bb9c-1eeed1f4071d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-d1e0-7679-bb9c-1eeed1f4071d",
        "storage_key": "property/6767906449167660/019ffd1c-d1e0-7679-bb9c-1eeed1f4071d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.esquiretavern-sa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6822742892410802772&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-esquire-tavern",
      "poi_latitude": "29.4247353",
      "poi_longitude": "-98.4918563",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-222-2521",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-4b28-7718-830a-91b4f67eb85f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-4b28-7718-830a-91b4f67eb85f",
        "storage_key": "property/6767906449167660/019ffd1d-4b28-7718-830a-91b4f67eb85f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSzUPzqxYXIYRVJL3H4NAr14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_3704eb8c-ce2a-4462-8681-1cd34dbfa67e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Biga - San Antonio Riverwalk Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "203 S St Mary's St, San Antonio, TX 78205, USA",
      "poi_short_description": "Chic River Walk eatery with adventurous New American fare, worldly wines & an ever-changing menu.",
      "poi_long_description": "Chic River Walk eatery with adventurous New American fare, worldly wines & an ever-changing menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-c242-716f-bb49-17074f3361b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-c242-716f-bb49-17074f3361b0",
        "storage_key": "property/6767906449167660/019ffd1c-c242-716f-bb49-17074f3361b0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://biga.com/?utm_source=GoogleLocal&utm_campaign=GoogleLocal",
      "poi_directions_map_url": "https://maps.google.com/?cid=16032547321510139907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "biga---san-antonio-riverwalk-restaurant",
      "poi_latitude": "29.423704",
      "poi_longitude": "-98.492007",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-225-0722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4a3-724d-8bfb-4bdaf679d305",
        "storage_key": "property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJU9YM56xYXIYRA5hAR9gMf94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_cb984473-7ca1-4267-94f7-37bff58a9ad9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Iron Cactus Mexican Restaurant and Margarita Bar",
      "poi_type": "Restaurants",
      "poi_address": "200 River Walk Suite 100, San Antonio, TX 78205, USA",
      "poi_short_description": "Outpost of a Texas chain with traditional & modern fare, happy hour & many tequilas.",
      "poi_long_description": "Outpost of a Texas chain with traditional & modern fare, happy hour & many tequilas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-d1e0-7679-bb9c-1b77ed471706.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-d1e0-7679-bb9c-1b77ed471706",
        "storage_key": "property/6767906449167660/019ffd1c-d1e0-7679-bb9c-1b77ed471706.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ironcactus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1030424582055903414&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iron-cactus-mexican-restaurant-and-margarita-bar",
      "poi_latitude": "29.4250659",
      "poi_longitude": "-98.490837",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-224-9835",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4a3-724d-8bfb-4bdaf679d305",
        "storage_key": "property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIWAlEKtYXIYRtsBFrbLNTA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_86727f18-717c-4c6f-a704-3c6f05485308",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Ostra Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "212 W Crockett St, San Antonio, TX 78205, USA",
      "poi_short_description": "Upscale seafood destination in the Mokara Hotel with a raw bar plus a long wine list & river views.",
      "poi_long_description": "Upscale seafood destination in the Mokara Hotel with a raw bar plus a long wine list & river views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-ccb4-70ee-87e8-c6d34ddcce38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-ccb4-70ee-87e8-c6d34ddcce38",
        "storage_key": "property/6767906449167660/019ffd1c-ccb4-70ee-87e8-c6d34ddcce38.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.omnihotels.com/hotels/san-antonio-mokara/dining/ostra?utm_source=gmblisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=16884532699064851737&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ostra-restaurant",
      "poi_latitude": "29.424682",
      "poi_longitude": "-98.4905383",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-396-5817",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4a3-724d-8bfb-4bdaf679d305",
        "storage_key": "property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIadIsKxYXIYRGV06HgjpUeo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_8a3a3652-e899-458d-bfe3-b1ef8b40a055",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Boudro's on the Riverwalk",
      "poi_type": "Restaurants",
      "poi_address": "On The Riverwalk Level, 421 E Commerce St, San Antonio, TX 78205, USA",
      "poi_short_description": "Hip New American bistro with wood-grilled steaks, seafood, tableside guacamole, cocktails & a patio.",
      "poi_long_description": "Hip New American bistro with wood-grilled steaks, seafood, tableside guacamole, cocktails & a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-c1ee-76ae-9c74-21e802f073f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-c1ee-76ae-9c74-21e802f073f5",
        "storage_key": "property/6767906449167660/019ffd1c-c1ee-76ae-9c74-21e802f073f5.webp",
        "width": 620,
        "height": 310
      },
      "poi_business_url": "http://www.boudros.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5434842793229321958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boudros-on-the-riverwalk",
      "poi_latitude": "29.4240604",
      "poi_longitude": "-98.4883378",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-224-8484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4a3-724d-8bfb-4bdaf679d305",
        "storage_key": "property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdRSMP6tYXIYR5oaGtLlwbEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bistro"
    },
    {
      "id": "custom_2652ab73-152e-4f01-bd73-5c21fd81bbad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Tre Trattoria",
      "poi_type": "Restaurants",
      "poi_address": "200 W Jones Ave #501, San Antonio, TX 78215, USA",
      "poi_short_description": "Trendy Italian eatery serving pasta, pizzas & family-style mains in airy digs with a patio & bar.",
      "poi_long_description": "Trendy Italian eatery serving pasta, pizzas & family-style mains in airy digs with a patio & bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-c5ab-72ee-8264-567b873d86e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-c5ab-72ee-8264-567b873d86e8",
        "storage_key": "property/6767906449167660/019ffd1c-c5ab-72ee-8264-567b873d86e8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tretrattoria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5922915639640537428&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tre-trattoria",
      "poi_latitude": "29.4367248",
      "poi_longitude": "-98.4814667",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 210-805-0333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4a3-724d-8bfb-4bdaf679d305",
        "storage_key": "property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8SkZWZf1XIYRVDlhr2RsMlI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_4d5ab49a-3154-49e2-b820-84d2de4c336c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Mi Tierra Cafe y Panaderia",
      "poi_type": "Restaurants",
      "poi_address": "218 Produce Row, San Antonio, TX 78207, USA",
      "poi_short_description": "Historic Mexican cafe and bakery offering classic fare, Tex-Mex dishes, margaritas, and mariachis in festive digs.",
      "poi_long_description": "Historic Mexican cafe and bakery offering classic fare, Tex-Mex dishes, margaritas, and mariachis in festive digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-6e93-729c-8b90-0b685b3983d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd17-6e93-729c-8b90-0b685b3983d2",
        "storage_key": "property/6767906449167660/019ffd17-6e93-729c-8b90-0b685b3983d2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://mitierracafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8598934189318908430&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mi-tierra-cafe-y-panaderia",
      "poi_latitude": "29.4249679",
      "poi_longitude": "-98.4997053",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-225-1262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4a3-724d-8bfb-4bdaf679d305",
        "storage_key": "property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu4MuskxfXIYRDqpQCRaNVXc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_d5b872de-13ce-4364-bc04-da7ff2a8a1dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "La Margarita Mexican Restaurant & Oyster Bar",
      "poi_type": "Restaurants",
      "poi_address": "120 Produce Row, San Antonio, TX 78207, USA",
      "poi_short_description": "Lively Market Square eatery with sizzling fajitas, seafood, margaritas, mariachis & patio dining.",
      "poi_long_description": "Lively Market Square eatery with sizzling fajitas, seafood, margaritas, mariachis & patio dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-ca6a-71e5-9275-18978eaa2e7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-ca6a-71e5-9275-18978eaa2e7f",
        "storage_key": "property/6767906449167660/019ffd1c-ca6a-71e5-9275-18978eaa2e7f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lamargarita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1860637334961964454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-margarita-mexican-restaurant--oyster-bar",
      "poi_latitude": "29.4249299",
      "poi_longitude": "-98.4990776",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-898-1745",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4a3-724d-8bfb-4bdaf679d305",
        "storage_key": "property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ44hzy0xfXIYRpsU8TsxP0hk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_3360c3e5-7bd7-4311-afac-ea61ef43d30d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Southerleigh Fine Food & Brewery",
      "poi_type": "Restaurants",
      "poi_address": "136 E Grayson St Suite 120, San Antonio, TX 78215, USA",
      "poi_short_description": "This eatery serving Texas cuisine in a historic space also offers a second-story microbrewery.",
      "poi_long_description": "This eatery serving Texas cuisine in a historic space also offers a second-story microbrewery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-c6ec-7769-b457-c9c6b47285cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-c6ec-7769-b457-c9c6b47285cb",
        "storage_key": "property/6767906449167660/019ffd1c-c6ec-7769-b457-c9c6b47285cb.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.southerleighatpearl.com/?y_source=1_MTA1NjI1NDkxMC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9421338573375328974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southerleigh-fine-food--brewery",
      "poi_latitude": "29.4425203",
      "poi_longitude": "-98.4806628",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-455-5701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4a3-724d-8bfb-4bdaf679d305",
        "storage_key": "property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJszniNvT1XIYRztK4HoRRv4I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3588f921-6d47-4f27-9aad-500816bd59b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Local Coffee",
      "poi_type": "Restaurants",
      "poi_address": "302 Pearl Pkwy, San Antonio, TX 78215, USA",
      "poi_short_description": "Buzzy coffeehouse offering a changing selection of brews in an intimate, industrial-chic setting.",
      "poi_long_description": "Buzzy coffeehouse offering a changing selection of brews in an intimate, industrial-chic setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-c686-7682-9185-95f5e7f63417.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-c686-7682-9185-95f5e7f63417",
        "storage_key": "property/6767906449167660/019ffd1c-c686-7682-9185-95f5e7f63417.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.localcoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9406614803922408235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "local-coffee",
      "poi_latitude": "29.4421439",
      "poi_longitude": "-98.4794638",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-530-1004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-4b29-710f-b699-1ddbbfdd3e54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-4b29-710f-b699-1ddbbfdd3e54",
        "storage_key": "property/6767906449167660/019ffd1d-4b29-710f-b699-1ddbbfdd3e54.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJpXGVtvb1XIYRK9O5ZlMCi4I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_06f68bce-371a-4fd9-8514-ad91218faf74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Bohanan's Prime Steaks and Seafood",
      "poi_type": "Restaurants",
      "poi_address": "219 E Houston St #275, San Antonio, TX 78205, USA",
      "poi_short_description": "Chic eatery serving American fare in an old-world setting with a cocktail lounge, patio & live jazz.",
      "poi_long_description": "Chic eatery serving American fare in an old-world setting with a cocktail lounge, patio & live jazz.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-d04f-77fc-8049-145c27a95440.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-d04f-77fc-8049-145c27a95440",
        "storage_key": "property/6767906449167660/019ffd1c-d04f-77fc-8049-145c27a95440.webp",
        "width": 1250,
        "height": 750
      },
      "poi_business_url": "http://www.bohanans.com/?utm_source=google&utm_medium=local&utm_campaign=1&utm_content=primary",
      "poi_directions_map_url": "https://maps.google.com/?cid=1499684603831171043&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bohanans-prime-steaks-and-seafood",
      "poi_latitude": "29.4267169",
      "poi_longitude": "-98.4903776",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-472-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4a3-724d-8bfb-4bdaf679d305",
        "storage_key": "property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbYly-VJfXIYR47d6ljPzzxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_f45fc8b8-84ed-4d2e-83b5-5c8fed57feb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Zocca Cuisine D’Italia",
      "poi_type": "Restaurants",
      "poi_address": "420 W Market St, San Antonio, TX 78205, USA",
      "poi_short_description": "Contemporary Italian cuisine (pizza, pasta & entrees) in a relaxed, riverside spot at the Westin.",
      "poi_long_description": "Contemporary Italian cuisine (pizza, pasta & entrees) in a relaxed, riverside spot at the Westin.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-da05-774c-bfc6-814b9b861a13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-da05-774c-bfc6-814b9b861a13",
        "storage_key": "property/6767906449167660/019ffd1c-da05-774c-bfc6-814b9b861a13.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://zoccariverwalk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4446077878483178442&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zocca-cuisine-ditalia",
      "poi_latitude": "29.4234533",
      "poi_longitude": "-98.4907678",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-224-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4a3-724d-8bfb-4bdaf679d305",
        "storage_key": "property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJU_uYlqxYXIYRylO2Lkaksz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_592f726e-18b0-4f83-90b9-f19dde99f9dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "La Villita Cafe",
      "poi_type": "Restaurants",
      "poi_address": "418 Villita St, San Antonio, TX 78205, USA",
      "poi_short_description": "Local art lines the walls of this comfy cafe with local craft beer on tap & counter seats.",
      "poi_long_description": "Local art lines the walls of this comfy cafe with local craft beer on tap & counter seats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-df2e-7671-a367-52511d9237ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-df2e-7671-a367-52511d9237ce",
        "storage_key": "property/6767906449167660/019ffd1c-df2e-7671-a367-52511d9237ce.webp",
        "width": 1247,
        "height": 1280
      },
      "poi_business_url": "http://lavillitacafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7713026543530684626&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-villita-cafe",
      "poi_latitude": "29.4214682",
      "poi_longitude": "-98.4891433",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-223-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-4b29-710f-b699-1ddbbfdd3e54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-4b29-710f-b699-1ddbbfdd3e54",
        "storage_key": "property/6767906449167660/019ffd1d-4b29-710f-b699-1ddbbfdd3e54.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJExdrnqtYXIYR0jBOpsYsCms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_3822985d-4cc7-4ae7-824f-c8d3f037469b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Paesanos Riverwalk",
      "poi_type": "Restaurants",
      "poi_address": "111 W Crockett St Suite 101, San Antonio, TX 78205, USA",
      "poi_short_description": "Upscale destination with traditional & contemporary Italian fare, a long wine list & outdoor dining.",
      "poi_long_description": "Upscale destination with traditional & contemporary Italian fare, a long wine list & outdoor dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-e3c4-732b-a3dd-9daa604fb814.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-e3c4-732b-a3dd-9daa604fb814",
        "storage_key": "property/6767906449167660/019ffd1c-e3c4-732b-a3dd-9daa604fb814.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.paesanosriverwalk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11710448536429269479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paesanos-riverwalk",
      "poi_latitude": "29.42536999999999",
      "poi_longitude": "-98.4889198",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-227-2782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4a3-724d-8bfb-4bdaf679d305",
        "storage_key": "property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw2ODlqxYXIYR5xFcNubeg6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_bbdaa04c-1fc5-42e7-81ef-55ea18832e1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Rita's on the River",
      "poi_type": "Restaurants",
      "poi_address": "River Level, 245 E Commerce St, San Antonio, TX 78205, USA",
      "poi_short_description": "Casual restaurant serving fajitas and tacos, plus margaritas and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-d9c0-76b9-aa34-12f3112a3739.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-d9c0-76b9-aa34-12f3112a3739",
        "storage_key": "property/6767906449167660/019ffd1c-d9c0-76b9-aa34-12f3112a3739.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://www.ritasontheriver.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=902248974909025953&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ritas-on-the-river",
      "poi_latitude": "29.4246701",
      "poi_longitude": "-98.4900392",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-227-7482",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4a3-724d-8bfb-4bdaf679d305",
        "storage_key": "property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJRmwqKxYXIYRoa5pkKluhQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_241bb498-0428-4c50-b0fa-a7ac166c1829",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "1915 Broadway STE 101, San Antonio, TX 78215, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-df85-7448-adc8-76ac0536c6d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-df85-7448-adc8-76ac0536c6d2",
        "storage_key": "property/6767906449167660/019ffd1c-df85-7448-adc8-76ac0536c6d2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/san-antonio-tx-pharmacies/1915-broadway-street-ste-101-san-antonio-tx-78215/storeid=11328?WT.mc_id=LS_GOOGLE_FS_11328",
      "poi_directions_map_url": "https://maps.google.com/?cid=9372314853391241396&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "29.4437488",
      "poi_longitude": "-98.4767631",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 210-806-8741",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c8-75d9-9b8e-94e897b41509",
        "storage_key": "property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQefZ1bn1XIYRtJCA17MmEYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_e14b816e-e68d-48d0-968a-63c02133a414",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Royal Blue Grocery",
      "poi_type": "Shopping & Retail",
      "poi_address": "122 E Houston St #101, San Antonio, TX 78205, USA",
      "poi_short_description": "Specialty market offering grocery basics, plus local wine, beer & ready-to-eat meals until late.",
      "poi_long_description": "Specialty market offering grocery basics, plus local wine, beer & ready-to-eat meals until late.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-e440-7710-af3e-b48aa13c04b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-e440-7710-af3e-b48aa13c04b4",
        "storage_key": "property/6767906449167660/019ffd1c-e440-7710-af3e-b48aa13c04b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.royalbluegrocery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7939641331193296320&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "royal-blue-grocery",
      "poi_latitude": "29.4263772",
      "poi_longitude": "-98.4925965",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-957-0093",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-4b2a-776d-970c-45a7f178a4f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-4b2a-776d-970c-45a7f178a4f8",
        "storage_key": "property/6767906449167660/019ffd1d-4b2a-776d-970c-45a7f178a4f8.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJubfCxnBfXIYRwDXJhblFL24",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_9d42ff1e-e5a2-4b55-9664-0090c5f73fd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Pullman Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "221 Newell Ave, San Antonio, TX 78215, USA",
      "poi_short_description": "Butcher with a grocery selection and a few restaurants and bars.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-e54c-721e-8c43-d30b155d25f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-e54c-721e-8c43-d30b155d25f6",
        "storage_key": "property/6767906449167660/019ffd1c-e54c-721e-8c43-d30b155d25f6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pullmanmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9221087259901853190&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pullman-market",
      "poi_latitude": "29.4413279",
      "poi_longitude": "-98.480731",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-759-0086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c2-70ee-a111-8bef185f2dec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c2-70ee-a111-8bef185f2dec",
        "storage_key": "property/6767906449167660/019ffd17-a4c2-70ee-a111-8bef185f2dec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp4maawD1XIYRBn5U6QHi938",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_99ae5c7d-fcb2-4978-b66a-5790ae99109c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Pearl Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "312 Pearl Pkwy, San Antonio, TX 78215, USA",
      "poi_short_description": "Hip outdoor space hosting local produce, meat & cheese producers, live music & cooking demos.",
      "poi_long_description": "Hip outdoor space hosting local produce, meat & cheese producers, live music & cooking demos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-eb34-7163-a4b7-883813cc2594.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-eb34-7163-a4b7-883813cc2594",
        "storage_key": "property/6767906449167660/019ffd1c-eb34-7163-a4b7-883813cc2594.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://atpearl.com/weekend-market/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7961303594882544524&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pearl-farmers-market",
      "poi_latitude": "29.4423775",
      "poi_longitude": "-98.4802075",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-212-7260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c2-70ee-a111-8f08e1624e86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c2-70ee-a111-8f08e1624e86",
        "storage_key": "property/6767906449167660/019ffd17-a4c2-70ee-a111-8f08e1624e86.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBeAiv_b1XIYRjLMDUnA7fG4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farmers_market"
    },
    {
      "id": "custom_a04fa4a7-29b5-4685-8a1e-bc9638ce800c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "west elm",
      "poi_type": "Shopping & Retail",
      "poi_address": "201 E Grayson St, San Antonio, TX 78215, USA",
      "poi_short_description": "Chain retailer offering a huge selection of modern furniture, home accessories & kitchen items.",
      "poi_long_description": "Chain retailer offering a huge selection of modern furniture, home accessories & kitchen items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-e8d5-7067-9449-b79f06b2ed37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-e8d5-7067-9449-b79f06b2ed37",
        "storage_key": "property/6767906449167660/019ffd1c-e8d5-7067-9449-b79f06b2ed37.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.westelm.com/stores/us-tx-san-antonio-pearl-district/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17542176415320152493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-elm",
      "poi_latitude": "29.444354",
      "poi_longitude": "-98.4791448",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-228-9859",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c2-70ee-a111-8f08e1624e86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c2-70ee-a111-8f08e1624e86",
        "storage_key": "property/6767906449167660/019ffd17-a4c2-70ee-a111-8f08e1624e86.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyf20DvT1XIYRrZlk3oFUcvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_4d532790-17a2-4946-b989-1569dfc3ccf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "The Twig Book Shop",
      "poi_type": "Shopping & Retail",
      "poi_address": "306 Pearl Pkwy #106, San Antonio, TX 78215, USA",
      "poi_short_description": "Veteran indie store in an old brewery, offering books for kids & adults, plus readings & events.",
      "poi_long_description": "Veteran indie store in an old brewery, offering books for kids & adults, plus readings & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-f114-73b3-a295-fda5c75a9bcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-f114-73b3-a295-fda5c75a9bcd",
        "storage_key": "property/6767906449167660/019ffd1c-f114-73b3-a295-fda5c75a9bcd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thetwig.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13954123968032059387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-twig-book-shop",
      "poi_latitude": "29.4422164",
      "poi_longitude": "-98.4801678",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-826-6411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c2-70ee-a111-8f08e1624e86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c2-70ee-a111-8f08e1624e86",
        "storage_key": "property/6767906449167660/019ffd17-a4c2-70ee-a111-8f08e1624e86.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJacAEEPT1XIYR-69QGtEBp8E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_e0036e4a-fc1d-4691-aca9-5adbab90802d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Bakery Lorraine at the Pearl",
      "poi_type": "Restaurants",
      "poi_address": "306 Pearl Pkwy Ste 110, San Antonio, TX 78215, USA",
      "poi_short_description": "Bakeshop with a patio serving sandwiches & an array of cookies, tarts & muffins, plus coffee.",
      "poi_long_description": "Bakeshop with a patio serving sandwiches & an array of cookies, tarts & muffins, plus coffee.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-ea08-76ff-8409-32a32c0f5e98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-ea08-76ff-8409-32a32c0f5e98",
        "storage_key": "property/6767906449167660/019ffd1c-ea08-76ff-8409-32a32c0f5e98.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://bakerylorraine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5632739871990866331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bakery-lorraine-at-the-pearl",
      "poi_latitude": "29.4422978",
      "poi_longitude": "-98.4800231",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-862-5582",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4a3-724d-8bfb-4bdaf679d305",
        "storage_key": "property/6767906449167660/019ffd17-a4a3-724d-8bfb-4bdaf679d305.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS2NMvvb1XIYRm-Ex7hGDK04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_54c69cfe-19e6-4037-8470-92b2d4ede5aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Shops at Rivercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "849 E Commerce St, San Antonio, TX 78205, USA",
      "poi_short_description": "Mall on the Riverwalk featuring popular chain stores, restaurants, an IMAX movie theater & a hotel.",
      "poi_long_description": "Mall on the Riverwalk featuring popular chain stores, restaurants, an IMAX movie theater & a hotel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-6b6a-769f-aeec-1133a820bba8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd17-6b6a-769f-aeec-1133a820bba8",
        "storage_key": "property/6767906449167660/019ffd17-6b6a-769f-aeec-1133a820bba8.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://shoprivercenter.com/?utm_source=SAC&utm_medium=GMB&utm_campaign=2026",
      "poi_directions_map_url": "https://maps.google.com/?cid=10945786990514650927&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shops-at-rivercenter",
      "poi_latitude": "29.4238596",
      "poi_longitude": "-98.4851568",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-225-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c2-70ee-a111-8f08e1624e86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c2-70ee-a111-8f08e1624e86",
        "storage_key": "property/6767906449167660/019ffd17-a4c2-70ee-a111-8f08e1624e86.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJWQFYkapYXIYRL7-3TEY_55c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_7a6a588a-4b85-4206-a244-8c46d3e0eb3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "201 W Commerce St Ste 101, San Antonio, TX 78205, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-f2ab-7233-bacb-56e041a20564.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-f2ab-7233-bacb-56e041a20564",
        "storage_key": "property/6767906449167660/019ffd1c-f2ab-7233-bacb-56e041a20564.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tx/san-antonio/201-w-commerce-36890?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3263005817240796304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "29.4252998",
      "poi_longitude": "-98.4948514",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-354-3291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-4b2a-776d-970c-45a7f178a4f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-4b2a-776d-970c-45a7f178a4f8",
        "storage_key": "property/6767906449167660/019ffd1d-4b2a-776d-970c-45a7f178a4f8.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ-48orVJfXIYRkLyrrICGSC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_c4771b55-9161-4f79-b438-af6b4837bae5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Alamo City Liquor",
      "poi_type": "Shopping & Retail",
      "poi_address": "1311 N Alamo St, San Antonio, TX 78215, USA",
      "poi_short_description": "Beer, wine, and liquor store offering a wide selection of spirits including tequila.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-f5d5-72de-a646-3af180e88fd9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-f5d5-72de-a646-3af180e88fd9",
        "storage_key": "property/6767906449167660/019ffd1c-f5d5-72de-a646-3af180e88fd9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alamocityliquor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12720810933539402640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alamo-city-liquor",
      "poi_latitude": "29.4368483",
      "poi_longitude": "-98.4783071",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-490-9883",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c2-70ee-a111-8f08e1624e86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c2-70ee-a111-8f08e1624e86",
        "storage_key": "property/6767906449167660/019ffd17-a4c2-70ee-a111-8f08e1624e86.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJmS_f8Z71XIYRkHOFdCVmibA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "custom_f9c140bc-71ae-4cc8-838b-c8649a387427",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Providence Catholic School",
      "poi_type": "Education",
      "poi_address": "1215 N St Mary's St, San Antonio, TX 78215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-f688-719e-addc-945c60069790.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-f688-719e-addc-945c60069790",
        "storage_key": "property/6767906449167660/019ffd1c-f688-719e-addc-945c60069790.webp",
        "width": 1170,
        "height": 659
      },
      "poi_business_url": "https://www.providencecatholicschool.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18100957673505008731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-catholic-school",
      "poi_latitude": "29.4351103",
      "poi_longitude": "-98.4855884",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-224-6651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4e5-7073-90b2-d30185630952",
        "storage_key": "property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpXFauFdfXIYRW6yl3xmFM_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6822215a-8b71-4080-8cb2-80b489322525",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Central Catholic High School - San Antonio",
      "poi_type": "Education",
      "poi_address": "1403 N St Mary's St, San Antonio, TX 78215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-f94e-74b8-8a1f-eec8f5811b05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-f94e-74b8-8a1f-eec8f5811b05",
        "storage_key": "property/6767906449167660/019ffd1c-f94e-74b8-8a1f-eec8f5811b05.webp",
        "width": 750,
        "height": 749
      },
      "poi_business_url": "http://www.cchs-satx.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8652566620391611881&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-catholic-high-school---san-antonio",
      "poi_latitude": "29.4365666",
      "poi_longitude": "-98.4850347",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-225-6794",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4e5-7073-90b2-d30185630952",
        "storage_key": "property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDz3fk1dfXIYR6R3Ye38XFHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_1670dbb5-a139-44d1-b447-0e2cce785ed4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "CAST Tech High School",
      "poi_type": "Education",
      "poi_address": "637 N Main Ave, San Antonio, TX 78205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-f94f-7582-9a95-431487cea42f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-f94f-7582-9a95-431487cea42f",
        "storage_key": "property/6767906449167660/019ffd1c-f94f-7582-9a95-431487cea42f.webp",
        "width": 1280,
        "height": 954
      },
      "poi_business_url": "https://www.saisd.net/casttech",
      "poi_directions_map_url": "https://maps.google.com/?cid=8686934906349737651&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cast-tech-high-school",
      "poi_latitude": "29.4320878",
      "poi_longitude": "-98.4956737",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-554-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4e5-7073-90b2-d30185630952",
        "storage_key": "property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDW7u3FFfXIYRs9bqn0Uxjng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_148f50e6-6998-4ba3-b454-fed0d08c8fc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Travis Early College High School",
      "poi_type": "Education",
      "poi_address": "1915 N Main Ave, San Antonio, TX 78212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-ff88-72da-b286-24eb86eaed3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-ff88-72da-b286-24eb86eaed3c",
        "storage_key": "property/6767906449167660/019ffd1c-ff88-72da-b286-24eb86eaed3c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.saisd.net/travisechs",
      "poi_directions_map_url": "https://maps.google.com/?cid=7380671294642563171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "travis-early-college-high-school",
      "poi_latitude": "29.4475201",
      "poi_longitude": "-98.4949556",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-738-9830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4e5-7073-90b2-d30185630952",
        "storage_key": "property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMQxwUV1fXIYRY6gXIXBpbWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_360575a4-3717-420a-881c-11cc158a7d4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "San Antonio College",
      "poi_type": "Education",
      "poi_address": "1819 N Main Ave, San Antonio, TX 78212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-764b-7119-8de8-0f32fc874667.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd17-764b-7119-8de8-0f32fc874667",
        "storage_key": "property/6767906449167660/019ffd17-764b-7119-8de8-0f32fc874667.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alamo.edu/sac/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12153728245465743446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-college",
      "poi_latitude": "29.4457849",
      "poi_longitude": "-98.4959969",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-486-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4e5-7073-90b2-d30185630952",
        "storage_key": "property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ1nBxEJfXIYRVgCeL3K3qqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1e1a73e6-e6ca-4584-b568-86a34b7ad6f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "San Antonio Academy",
      "poi_type": "Education",
      "poi_address": "117 E French Pl, San Antonio, TX 78212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1c-fff2-71e3-9d50-bfc7edf46c24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-fff2-71e3-9d50-bfc7edf46c24",
        "storage_key": "property/6767906449167660/019ffd1c-fff2-71e3-9d50-bfc7edf46c24.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.sa-academy.org/?utm_source=Google+Business+Profile&utm_medium=organic&utm_campaign=%28TT%29-SAA-GBP",
      "poi_directions_map_url": "https://maps.google.com/?cid=17351904781833793052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-academy",
      "poi_latitude": "29.4508248",
      "poi_longitude": "-98.4929031",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-733-7331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4e5-7073-90b2-d30185630952",
        "storage_key": "property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa-kVrGdfXIYRHO6a-XZZzvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_82f2fa1c-ecf2-4f05-922f-9e367ee87da9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Keystone School",
      "poi_type": "Education",
      "poi_address": "119 E Craig Pl, San Antonio, TX 78212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-0058-7191-8d09-24276199479e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-0058-7191-8d09-24276199479e",
        "storage_key": "property/6767906449167660/019ffd1d-0058-7191-8d09-24276199479e.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.keystoneschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6220114826233729314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "keystone-school",
      "poi_latitude": "29.4522731",
      "poi_longitude": "-98.4931015",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-735-4022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4e5-7073-90b2-d30185630952",
        "storage_key": "property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT1VKXGZfXIYRIlHNl3pJUlY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_d66b0fc2-73ac-4c38-a105-22d4462d8e2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Nathaniel Hawthorne Academy",
      "poi_type": "Education",
      "poi_address": "115 W Josephine St, San Antonio, TX 78212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-0c78-7508-a73a-be41ec49e03a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-0c78-7508-a73a-be41ec49e03a",
        "storage_key": "property/6767906449167660/019ffd1d-0c78-7508-a73a-be41ec49e03a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.saisd.net/hawthorneacademy",
      "poi_directions_map_url": "https://maps.google.com/?cid=9815288933465603440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nathaniel-hawthorne-academy",
      "poi_latitude": "29.4464221",
      "poi_longitude": "-98.4828749",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-738-9795",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4e5-7073-90b2-d30185630952",
        "storage_key": "property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2ykuc_X1XIYRcD0KB0jpNog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7c9d9c43-b5de-4e58-8e3f-6875b74056e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Trinity University",
      "poi_type": "Education",
      "poi_address": "1 Trinity Pl, San Antonio, TX 78212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-7646-722a-89f0-c311c6400d21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd17-7646-722a-89f0-c311c6400d21",
        "storage_key": "property/6767906449167660/019ffd17-7646-722a-89f0-c311c6400d21.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.trinity.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1542864360290490523&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-university",
      "poi_latitude": "29.4618769",
      "poi_longitude": "-98.4833382",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-999-7011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4e5-7073-90b2-d30185630952",
        "storage_key": "property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxbr4W5lhXIYRm5i5E_ZaaRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_89090b09-7e76-4c8b-9687-5ff56b99b872",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Discovery World Learning Center",
      "poi_type": "Education",
      "poi_address": "406 W César E Chávez Blvd, San Antonio, TX 78204, USA",
      "poi_short_description": "Since 1992, this day care center has offered age-appropriate programs and after-school care.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-0886-747d-b2d9-8bf68bb46188.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-0886-747d-b2d9-8bf68bb46188",
        "storage_key": "property/6767906449167660/019ffd1d-0886-747d-b2d9-8bf68bb46188.webp",
        "width": 1280,
        "height": 631
      },
      "poi_business_url": "http://www.discoveryworldsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10059893914210534082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "discovery-world-learning-center",
      "poi_latitude": "29.4217033",
      "poi_longitude": "-98.5007827",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-225-7464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4e5-7073-90b2-d30185630952",
        "storage_key": "property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPTheeLNYXIYRwgKiIjfsm4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_03e4cacb-5409-46e8-bc5d-8dadf1d21dad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Tobin Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "100 Auditorium Cir, San Antonio, TX 78205, USA",
      "poi_short_description": "Large venue hosting Broadway tours and concerts of many genres, plus ballet and other live events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-03d1-747d-99aa-3449d22a47db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-03d1-747d-99aa-3449d22a47db",
        "storage_key": "property/6767906449167660/019ffd1d-03d1-747d-99aa-3449d22a47db.webp",
        "width": 930,
        "height": 523
      },
      "poi_business_url": "https://www.tobincenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12854864989977135831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tobin-center-for-the-performing-arts",
      "poi_latitude": "29.4306593",
      "poi_longitude": "-98.4887048",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-223-8624",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c8-75d9-9b8e-94e897b41509",
        "storage_key": "property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfVwRGlRfXIYR10oxs5mnZbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_1de30bb1-6f09-40f8-b971-2cf590583d5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Majestic Theatre",
      "poi_type": "Entertainment",
      "poi_address": "224 E Houston St, San Antonio, TX 78205, USA",
      "poi_short_description": "This ornate Mediterranean-style landmark built in 1929 features touring concerts & Broadway shows.",
      "poi_long_description": "This ornate Mediterranean-style landmark built in 1929 features touring concerts & Broadway shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-080e-740f-a78a-a00ee1e59ce4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-080e-740f-a78a-a00ee1e59ce4",
        "storage_key": "property/6767906449167660/019ffd1d-080e-740f-a78a-a00ee1e59ce4.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://us.atgtickets.com/venues/majestic-theatre/whats-on/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5135301984976611197&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "majestic-theatre",
      "poi_latitude": "29.4261726",
      "poi_longitude": "-98.4906058",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 888-811-5040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c8-75d9-9b8e-94e897b41509",
        "storage_key": "property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfZxkRFNfXIYRfafjhPJBREc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_76b9d9aa-49f1-4d02-af34-90bfe87df639",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Aztec Theatre",
      "poi_type": "Entertainment",
      "poi_address": "104 N St Mary's St, San Antonio, TX 78205, USA",
      "poi_short_description": "Ornate concert venue that also stages plays, films and weddings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-08e8-71de-a8bf-38ec3fe1634a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-08e8-71de-a8bf-38ec3fe1634a",
        "storage_key": "property/6767906449167660/019ffd1d-08e8-71de-a8bf-38ec3fe1634a.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.theaztectheatre.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=7852487536378228343&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aztec-theatre",
      "poi_latitude": "29.4247856",
      "poi_longitude": "-98.4910964",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-812-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c8-75d9-9b8e-94e897b41509",
        "storage_key": "property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXYrXrP1ZXIYRd64BYc-j-Ww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_1d3f3cf7-cf55-469d-8c51-41d07d001e30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "San Antonio Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "200 W Jones Ave, San Antonio, TX 78215, USA",
      "poi_short_description": "Egyptian, Greek, Roman, Latin American & contemporary collections in the former Lone Star Brewery.",
      "poi_long_description": "Egyptian, Greek, Roman, Latin American & contemporary collections in the former Lone Star Brewery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-0a88-71d8-bf7a-f46874a92d89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-0a88-71d8-bf7a-f46874a92d89",
        "storage_key": "property/6767906449167660/019ffd1d-0a88-71d8-bf7a-f46874a92d89.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.samuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8027482300510423073&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-museum-of-art",
      "poi_latitude": "29.4372761",
      "poi_longitude": "-98.4821898",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 210-978-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4a9-77ce-86b6-fde69c9e25e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4a9-77ce-86b6-fde69c9e25e0",
        "storage_key": "property/6767906449167660/019ffd17-a4a9-77ce-86b6-fde69c9e25e0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJGR8ZJvj1XIYRIcio8p5YZ28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_07ee983a-3414-4e13-ba94-756f8cfde598",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "The Alamo",
      "poi_type": "Entertainment",
      "poi_address": "300 Alamo Plaza, San Antonio, TX 78205, USA",
      "poi_short_description": "Small, shrinelike fortress & monument to Texas history with a museum, artifacts, gardens & more.",
      "poi_long_description": "Small, shrinelike fortress & monument to Texas history with a museum, artifacts, gardens & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-0c77-712c-b584-850482049114.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-0c77-712c-b584-850482049114",
        "storage_key": "property/6767906449167660/019ffd1d-0c77-712c-b584-850482049114.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.thealamo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1727569228890358818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-alamo",
      "poi_latitude": "29.4259671",
      "poi_longitude": "-98.4861419",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-225-1391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4ca-7482-ab08-cbd5fac2afe6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4ca-7482-ab08-cbd5fac2afe6",
        "storage_key": "property/6767906449167660/019ffd17-a4ca-7482-ab08-cbd5fac2afe6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX4k2TVVfXIYRIsTnhA-P-Rc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_place"
    },
    {
      "id": "custom_5e509e35-70de-4901-9a52-d5673b6a2248",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "The Buckhorn Saloon & Museum",
      "poi_type": "Restaurants",
      "poi_address": "318 E Houston St, San Antonio, TX 78205, USA",
      "poi_short_description": "Old West-themed gift store stocking cowboy hats, T-shirts, Bowie knives & other sundries.",
      "poi_long_description": "Old West-themed gift store stocking cowboy hats, T-shirts, Bowie knives & other sundries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-0f24-74e1-918f-d937496cc39b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-0f24-74e1-918f-d937496cc39b",
        "storage_key": "property/6767906449167660/019ffd1d-0f24-74e1-918f-d937496cc39b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.buckhornmuseum.com/cafe-saloon",
      "poi_directions_map_url": "https://maps.google.com/?cid=17257640513239981002&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-buckhorn-saloon--museum",
      "poi_latitude": "29.4262235",
      "poi_longitude": "-98.4889712",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-247-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-4b28-7718-830a-91b4f67eb85f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-4b28-7718-830a-91b4f67eb85f",
        "storage_key": "property/6767906449167660/019ffd1d-4b28-7718-830a-91b4f67eb85f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbTSUulRfXIYRyhsPpZx0f-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_ca8f1fdb-3a71-413b-ae01-6134c9fee878",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "La Villita National Historic Village",
      "poi_type": "Entertainment",
      "poi_address": "418 Villita St, San Antonio, TX 78205, USA",
      "poi_short_description": "Square-block enclave of art galleries & shops, listed on the National Registry of Historic Places.",
      "poi_long_description": "Square-block enclave of art galleries & shops, listed on the National Registry of Historic Places.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-1d90-73e5-a75e-08df74c652af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-1d90-73e5-a75e-08df74c652af",
        "storage_key": "property/6767906449167660/019ffd1d-1d90-73e5-a75e-08df74c652af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lavillitasanantonio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8845209861127091899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-villita-national-historic-village",
      "poi_latitude": "29.4217035",
      "poi_longitude": "-98.4891147",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-207-8614",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4ca-7482-ab08-cbd5fac2afe6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4ca-7482-ab08-cbd5fac2afe6",
        "storage_key": "property/6767906449167660/019ffd17-a4ca-7482-ab08-cbd5fac2afe6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYXjllKtYXIYRuzZDOIF_wHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_ce70eb71-9c41-4963-a1d9-64e12e51e889",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Briscoe Western Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "210 W Market St, San Antonio, TX 78205, USA",
      "poi_short_description": "Modern museum housing art & artifacts reflecting the history & culture of the American West.",
      "poi_long_description": "Modern museum housing art & artifacts reflecting the history & culture of the American West.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-1958-71bf-bbe7-aff8f95d0b9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-1958-71bf-bbe7-aff8f95d0b9a",
        "storage_key": "property/6767906449167660/019ffd1d-1958-71bf-bbe7-aff8f95d0b9a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.briscoemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9049069619822621695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "briscoe-western-art-museum",
      "poi_latitude": "29.4229603",
      "poi_longitude": "-98.4891439",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-299-4499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4a9-77ce-86b6-fde69c9e25e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4a9-77ce-86b6-fde69c9e25e0",
        "storage_key": "property/6767906449167660/019ffd17-a4a9-77ce-86b6-fde69c9e25e0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJP8iNQatYXIYR_3NODeDAlH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_d8e762db-cdd9-4837-afc0-ddb8f461170b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "San Fernando Cathedral",
      "poi_type": "Entertainment",
      "poi_address": "115 Main Plaza, San Antonio, TX 78205, USA",
      "poi_short_description": "Historic 1738 church once occupied by General Santa Ana & the site Pope John Paul II's visit.",
      "poi_long_description": "Historic 1738 church once occupied by General Santa Ana & the site Pope John Paul II's visit.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-1896-714d-aea0-230823b196a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-1896-714d-aea0-230823b196a8",
        "storage_key": "property/6767906449167660/019ffd1d-1896-714d-aea0-230823b196a8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sfcathedral.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14651260751615471288&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-fernando-cathedral",
      "poi_latitude": "29.4245523",
      "poi_longitude": "-98.494132",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-227-1297",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-4b3f-73ba-b511-cc6b546b127a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-4b3f-73ba-b511-cc6b546b127a",
        "storage_key": "property/6767906449167660/019ffd1d-4b3f-73ba-b511-cc6b546b127a.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJv520Oa1YXIYRuK6pIwe8U8s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_495ae85a-60d1-4707-ac2d-27ca4ecf0058",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Baptist Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "111 Dallas St, San Antonio, TX 78205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-8cbe-77fd-b6c8-359628d5da5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd17-8cbe-77fd-b6c8-359628d5da5f",
        "storage_key": "property/6767906449167660/019ffd17-8cbe-77fd-b6c8-359628d5da5f.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "https://www.baptisthealthsystem.com/location/detail/baptist-medical-center/?utm_campaign=gmb_listings_mgmt&utm_source=gmb-baptist-medical-center&utm_medium=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3396036108956313548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-medical-center",
      "poi_latitude": "29.4334891",
      "poi_longitude": "-98.4923606",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-297-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c1-7525-bcaa-972cd6078d8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c1-7525-bcaa-972cd6078d8e",
        "storage_key": "property/6767906449167660/019ffd17-a4c1-7525-bcaa-972cd6078d8e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJN5VRVlBfXIYRzKe9HtkkIS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_daad9deb-775d-4f64-85d0-c49fd2382e21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "CHRISTUS Children's",
      "poi_type": "Health and Wellness",
      "poi_address": "333 N Santa Rosa St, San Antonio, TX 78207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-1f91-7487-a72a-f6e45e359a6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-1f91-7487-a72a-f6e45e359a6d",
        "storage_key": "property/6767906449167660/019ffd1d-1f91-7487-a72a-f6e45e359a6d.webp",
        "width": 1280,
        "height": 989
      },
      "poi_business_url": "https://www.christushealth.org/locations/childrens-hospital?utm_source=GBP&utm_medium=organic&utm_campaign=GBP-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12991254685047924425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christus-childrens",
      "poi_latitude": "29.4269652",
      "poi_longitude": "-98.498613",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-704-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c1-7525-bcaa-972cd6078d8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c1-7525-bcaa-972cd6078d8e",
        "storage_key": "property/6767906449167660/019ffd17-a4c1-7525-bcaa-972cd6078d8e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJF8VlUExfXIYRySbpME41SrQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ce0668e0-ebfd-4df4-bd7e-502eda7d79f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Concentra Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "400 E Quincy St, San Antonio, TX 78215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-1e5a-7768-bc98-b031466ca8eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-1e5a-7768-bc98-b031466ca8eb",
        "storage_key": "property/6767906449167660/019ffd1d-1e5a-7768-bc98-b031466ca8eb.webp",
        "width": 1280,
        "height": 887
      },
      "poi_business_url": "http://www.concentra.com/?utm_source=Yext&utm_medium=Organic&utm_campaign=Homepage%20Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=2581898154599869765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concentra-urgent-care",
      "poi_latitude": "29.4362314",
      "poi_longitude": "-98.4904106",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-472-0211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c8-75d9-9b8e-94e897b41509",
        "storage_key": "property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9_LwoVBfXIYRRW0pL7G-1CM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_ba168541-274b-46cc-a496-abdd60af6e2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "HOTWORX - San Antonio, TX - South Broadway",
      "poi_type": "Health and Wellness",
      "poi_address": "1011 Broadway, San Antonio, TX 78215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-1d45-73fc-8b11-d00520c28241.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-1d45-73fc-8b11-d00520c28241",
        "storage_key": "property/6767906449167660/019ffd1d-1d45-73fc-8b11-d00520c28241.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.hotworx.net/studio/sanantonio-southbroadway?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=7341274312219575603&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---san-antonio-tx---south-broadway",
      "poi_latitude": "29.43490379999999",
      "poi_longitude": "-98.4805173",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 210-254-9250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4e5-7073-90b2-d30185630952",
        "storage_key": "property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUbzRYrv1XIYRM0WMWhdy4WU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_b0244a41-8a05-4f46-895d-6e97bc8616db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Black Swan Yoga San Antonio - Downtown",
      "poi_type": "Health and Wellness",
      "poi_address": "914 E Elmira St #201, San Antonio, TX 78212, USA",
      "poi_short_description": "Yoga chain offering classes for all levels in a clean studio with a spacious parking lot.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-2047-7496-b4ea-4cf1625bf7b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-2047-7496-b4ea-4cf1625bf7b7",
        "storage_key": "property/6767906449167660/019ffd1d-2047-7496-b4ea-4cf1625bf7b7.webp",
        "width": 1109,
        "height": 1280
      },
      "poi_business_url": "https://blackswanyoga.com/san-antonio/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14460014588349023427&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-swan-yoga-san-antonio---downtown",
      "poi_latitude": "29.4409238",
      "poi_longitude": "-98.4852478",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-570-6555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4e5-7073-90b2-d30185630952",
        "storage_key": "property/6767906449167660/019ffd17-a4e5-7073-90b2-d30185630952.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoe1CQDFfXIYRw4SC2adKrMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_dfaf97ab-6cfc-42bb-8e7d-ea3009e6f889",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Transcend Health Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "914 E Elmira St Ste 204, San Antonio, TX 78212, USA",
      "poi_short_description": "Relaxed spa offering float therapy, yoga classes, massages, saunas and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-2365-747b-90d8-255c405419ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-2365-747b-90d8-255c405419ec",
        "storage_key": "property/6767906449167660/019ffd1d-2365-747b-90d8-255c405419ec.webp",
        "width": 1280,
        "height": 1185
      },
      "poi_business_url": "http://transcendsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7988998224409844401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "transcend-health-spa",
      "poi_latitude": "29.4408049",
      "poi_longitude": "-98.4851739",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-920-8929",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c8-75d9-9b8e-94e897b41509",
        "storage_key": "property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp_EulUBfXIYRsdosvY6f3m4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "massage_spa"
    },
    {
      "id": "custom_7057a9fc-2fa6-4762-a64f-46f3b109c457",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "University Health Robert B. Green Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "903 W Martin St, San Antonio, TX 78207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-1d94-777c-810e-2954ec24129f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-1d94-777c-810e-2954ec24129f",
        "storage_key": "property/6767906449167660/019ffd1d-1d94-777c-810e-2954ec24129f.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "https://www.universityhealth.com/locations/robert-b-green-campus?utm_source=Yext&utm_medium=online_listings_location&utm_campaign=UH_digital&utm_content=Robert_B_Green_Campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=15961882843340738395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-health-robert-b-green-campus",
      "poi_latitude": "29.4307094",
      "poi_longitude": "-98.5017334",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-358-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c8-75d9-9b8e-94e897b41509",
        "storage_key": "property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVSW2JPldXIYRWw-6V-D_g90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_a39d226d-e36e-41b8-812d-523b5280eb6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Maverick Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1000 Broadway, San Antonio, TX 78215, USA",
      "poi_short_description": "A 3-acre lawn donated in 1881 by prominent San Antonian Sam Maverick, now used for community events.",
      "poi_long_description": "A 3-acre lawn donated in 1881 by prominent San Antonian Sam Maverick, now used for community events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-2cce-70bc-a688-2213747aa71a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-2cce-70bc-a688-2213747aa71a",
        "storage_key": "property/6767906449167660/019ffd1d-2cce-70bc-a688-2213747aa71a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sa.gov/Directory/Departments/Parks/Parks-Facilities/Parks/Directory/Maverick-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2858698153119929841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maverick-park",
      "poi_latitude": "29.4344345",
      "poi_longitude": "-98.4797266",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4e6-730d-bd18-180b9be0155c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4e6-730d-bd18-180b9be0155c",
        "storage_key": "property/6767906449167660/019ffd17-a4e6-730d-bd18-180b9be0155c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJI3ySdvn1XIYR8VXHANMirCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_96885008-78ef-41d7-a7ef-7fb8cf5f0d6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Madison Square Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "400 Lexington Ave, San Antonio, TX 78215, USA",
      "poi_short_description": "Urban green space with a fitness circuit, playground & picnic tables, plus an off-leash dog area.",
      "poi_long_description": "Urban green space with a fitness circuit, playground & picnic tables, plus an off-leash dog area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-2c85-72ba-b347-e3607e63411f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-2c85-72ba-b347-e3607e63411f",
        "storage_key": "property/6767906449167660/019ffd1d-2c85-72ba-b347-e3607e63411f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sanantonio.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1221889446806823031&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "madison-square-park",
      "poi_latitude": "29.4342253",
      "poi_longitude": "-98.4916419",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4e6-730d-bd18-180b9be0155c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4e6-730d-bd18-180b9be0155c",
        "storage_key": "property/6767906449167660/019ffd17-a4e6-730d-bd18-180b9be0155c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmWJC3VBfXIYRdyC4X_oF9RA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_304600e4-0c85-4e1c-afd4-e53b8010b1a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Arneson River Theatre",
      "poi_type": "Entertainment",
      "poi_address": "418 Villita St, San Antonio, TX 78205, USA",
      "poi_short_description": "Built in 1939, this open-air stage hosts riverfront performances from dance to music and opera.",
      "poi_long_description": "Built in 1939, this open-air stage hosts riverfront performances from dance to music and opera.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-2e0c-76e6-ae48-8c9766d1a916.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-2e0c-76e6-ae48-8c9766d1a916",
        "storage_key": "property/6767906449167660/019ffd1d-2e0c-76e6-ae48-8c9766d1a916.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.getcreativesanantonio.com/Explore-San-Antonio/La-Villita",
      "poi_directions_map_url": "https://maps.google.com/?cid=1695784380978684102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arneson-river-theatre",
      "poi_latitude": "29.42210069999999",
      "poi_longitude": "-98.4887824",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-207-8614",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c8-75d9-9b8e-94e897b41509",
        "storage_key": "property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTTbw6tYXIYRxuDj6-iiiBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_05aad2ec-ff6a-42ef-ad8e-d4c862e84f71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Yanaguana Garden at Hemisfair",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "434 S Alamo St, San Antonio, TX 78205, USA",
      "poi_short_description": "Modern park with innovative climbing structures & swings, a giant chessboard & colorful artworks.",
      "poi_long_description": "Modern park with innovative climbing structures & swings, a giant chessboard & colorful artworks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-3255-71ed-8024-81f5ab2b4222.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3255-71ed-8024-81f5ab2b4222",
        "storage_key": "property/6767906449167660/019ffd1d-3255-71ed-8024-81f5ab2b4222.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://hemisfair.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17715800802505384848&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yanaguana-garden-at-hemisfair",
      "poi_latitude": "29.4195662",
      "poi_longitude": "-98.4878609",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-709-4750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4e6-730d-bd18-180b9be0155c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4e6-730d-bd18-180b9be0155c",
        "storage_key": "property/6767906449167660/019ffd17-a4e6-730d-bd18-180b9be0155c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJK-t_YalYXIYRkOPpsPcq2_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_20c70e93-da62-4a13-9342-fb4910d49632",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Travis Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "301 E Travis St, San Antonio, TX 78205, USA",
      "poi_short_description": "Landscaped downtown square & events hub since 1870 on 2.6 acres with picnic & café style tables.",
      "poi_long_description": "Landscaped downtown square & events hub since 1870 on 2.6 acres with picnic & café style tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-30b0-74ea-a4cb-5a970e004000.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-30b0-74ea-a4cb-5a970e004000",
        "storage_key": "property/6767906449167660/019ffd1d-30b0-74ea-a4cb-5a970e004000.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.travisparksa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15072962023198485603&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "travis-park",
      "poi_latitude": "29.4281035",
      "poi_longitude": "-98.4891409",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-207-3677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4e6-730d-bd18-180b9be0155c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4e6-730d-bd18-180b9be0155c",
        "storage_key": "property/6767906449167660/019ffd17-a4e6-730d-bd18-180b9be0155c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXbBOhlRfXIYRY-yyoRnrLdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_321a2c3c-3324-4dd3-9298-8f4fbeffb583",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Plaza de Las Islas Canarias",
      "poi_type": "Entertainment",
      "poi_address": "115 N Main Ave, San Antonio, TX 78205, USA",
      "poi_short_description": "Shaded city square with water fountains overlooked by a Gothic Revival Catholic cathedral.",
      "poi_long_description": "Shaded city square with water fountains overlooked by a Gothic Revival Catholic cathedral.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-3184-75fd-a05d-c1ada0103124.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3184-75fd-a05d-c1ada0103124",
        "storage_key": "property/6767906449167660/019ffd1d-3184-75fd-a05d-c1ada0103124.webp",
        "width": 1246,
        "height": 1280
      },
      "poi_business_url": "http://www.mainplaza.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1214163917560556228&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plaza-de-las-islas-canarias",
      "poi_latitude": "29.4245662",
      "poi_longitude": "-98.4934673",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-225-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c8-75d9-9b8e-94e897b41509",
        "storage_key": "property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmawfoVJfXIYRxCpLbaaT2RA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "custom_e9c9bf67-0c46-4768-9041-74ed264d9306",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Milam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "500 W Commerce St, San Antonio, TX 78207, USA",
      "poi_short_description": "Community park with game tables, a gazebo, a children's playscape & exercise stations.",
      "poi_long_description": "Community park with game tables, a gazebo, a children's playscape & exercise stations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-33d5-766e-9e6f-28a4eb35bd29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-33d5-766e-9e6f-28a4eb35bd29",
        "storage_key": "property/6767906449167660/019ffd1d-33d5-766e-9e6f-28a4eb35bd29.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sanantonio.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6452638504495195018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "milam-park",
      "poi_latitude": "29.42603979999999",
      "poi_longitude": "-98.4991236",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4e6-730d-bd18-180b9be0155c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4e6-730d-bd18-180b9be0155c",
        "storage_key": "property/6767906449167660/019ffd17-a4e6-730d-bd18-180b9be0155c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNwwLwUxfXIYRiqNxRIhgjFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_e5f9586a-a909-44fb-a6c7-323511ced345",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Mahncke Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3400 Broadway, San Antonio, TX 78209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-38e2-713c-b2ca-ab1544b45463.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-38e2-713c-b2ca-ab1544b45463",
        "storage_key": "property/6767906449167660/019ffd1d-38e2-713c-b2ca-ab1544b45463.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sanantonio.gov/ParksAndRec/Parks-Facilities/All-Parks-Facilities/Parks-Facilities-Details/ArtMID/14820/ArticleID/2584/Park/135",
      "poi_directions_map_url": "https://maps.google.com/?cid=11599777176131847889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mahncke-park",
      "poi_latitude": "29.4580137",
      "poi_longitude": "-98.4673797",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4e6-730d-bd18-180b9be0155c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4e6-730d-bd18-180b9be0155c",
        "storage_key": "property/6767906449167660/019ffd17-a4e6-730d-bd18-180b9be0155c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw1LAV5b1XIYR0cYFKeKv-qA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_35017540-8332-4cbf-a250-09080dcf2a4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "San Antonio Amtrak Station (SAS)",
      "poi_type": "Transportation & Transit",
      "poi_address": "350 Hoefgen Ave, San Antonio, TX 78205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-3697-774c-8ae9-2d006a18b02f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3697-774c-8ae9-2d006a18b02f",
        "storage_key": "property/6767906449167660/019ffd1d-3697-774c-8ae9-2d006a18b02f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/stations/sas",
      "poi_directions_map_url": "https://maps.google.com/?cid=17315811974640798917&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-amtrak-station-sas",
      "poi_latitude": "29.4193893",
      "poi_longitude": "-98.4780423",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-367-9465",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c8-75d9-9b8e-94e897b41509",
        "storage_key": "property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUTDm0Sv3XIYRxYzrcT8fTvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "custom_70b91b73-d04c-4da4-87e9-6d095982524b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Greyhound Shop",
      "poi_type": "Transportation & Transit",
      "poi_address": "500 N St Mary's St, San Antonio, TX 78205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-3706-742a-9ccf-75f986a2f8a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3706-742a-9ccf-75f986a2f8a1",
        "storage_key": "property/6767906449167660/019ffd1d-3706-742a-9ccf-75f986a2f8a1.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.greyhound.com/bus/san-antonio-tx/san-antonio-bus-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=2193265979862775306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-shop",
      "poi_latitude": "29.4289054",
      "poi_longitude": "-98.4911807",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c8-75d9-9b8e-94e897b41509",
        "storage_key": "property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi7PjnzWWXIYRCnary8kLcB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f70bb774-da8e-42be-9da3-aeb87d3432dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "VIA Metropolitan Transit - Downtown Information Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "211 W Commerce St, San Antonio, TX 78205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-3895-7338-a8ba-f79e1be23a18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3895-7338-a8ba-f79e1be23a18",
        "storage_key": "property/6767906449167660/019ffd1d-3895-7338-a8ba-f79e1be23a18.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.viainfo.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10019018696236165120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "via-metropolitan-transit---downtown-information-center",
      "poi_latitude": "29.4252998",
      "poi_longitude": "-98.49495",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-362-2889",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c8-75d9-9b8e-94e897b41509",
        "storage_key": "property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB_t-Uk1fXIYRAGgn02u0Cos",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_c6e9bf4f-7e64-48bb-ab7b-1c4ef4340152",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "VIA Metro Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "1021 San Pedro Ave, San Antonio, TX 78212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-3f94-73cc-b487-12b443b74135.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3f94-73cc-b487-12b443b74135",
        "storage_key": "property/6767906449167660/019ffd1d-3f94-73cc-b487-12b443b74135.webp",
        "width": 949,
        "height": 1280
      },
      "poi_business_url": "http://www.viainfo.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7516257581784255112&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "via-metro-center",
      "poi_latitude": "29.4431317",
      "poi_longitude": "-98.4997932",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-362-2020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c8-75d9-9b8e-94e897b41509",
        "storage_key": "property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Qgl6ENfXIYRiEqWonIcT2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_f426b5a5-fd4f-454e-addb-25989d4f2dc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "San Antonio International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "9800 Airport Blvd, San Antonio, TX 78216, USA",
      "poi_short_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_long_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-38fb-71ae-abbe-67ff52d748ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-38fb-71ae-abbe-67ff52d748ac",
        "storage_key": "property/6767906449167660/019ffd1d-38fb-71ae-abbe-67ff52d748ac.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.flysanantonio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18041828760938859602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-international-airport",
      "poi_latitude": "29.5307982",
      "poi_longitude": "-98.4711194",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 210-207-3433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-4b2a-776d-970c-48094c873d87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-4b2a-776d-970c-48094c873d87",
        "storage_key": "property/6767906449167660/019ffd1d-4b2a-776d-970c-48094c873d87.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ4DLsbuKXIYRUswvGqtzYfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_b83d456a-2ee3-4665-9151-6ed7aaefbb13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "GO RIO San Antonio River Cruises",
      "poi_type": "Entertainment",
      "poi_address": "706 E River Walk, San Antonio, TX 78205, USA",
      "poi_short_description": "Tours of San Antonio's backwaters are offered on custom watercraft by this agency.",
      "poi_long_description": "Tours of San Antonio's backwaters are offered on custom watercraft by this agency.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-3ad6-73a7-9eaf-1d71a0cc0334.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3ad6-73a7-9eaf-1d71a0cc0334",
        "storage_key": "property/6767906449167660/019ffd1d-3ad6-73a7-9eaf-1d71a0cc0334.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.goriocruises.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6516930094593809936&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "go-rio-san-antonio-river-cruises",
      "poi_latitude": "29.4228325",
      "poi_longitude": "-98.4880228",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-227-4746",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c8-75d9-9b8e-94e897b41509",
        "storage_key": "property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr3MhZKtYXIYREB5RkmTJcFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_5220df6b-c1b7-4a2c-aa47-98fee53d857e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Pearl",
      "poi_type": "Entertainment",
      "poi_address": "303 Pearl Pkwy, San Antonio, TX 78215, USA",
      "poi_short_description": "Historic brewery complex now offering dining, shopping, a farmers' market & event space.",
      "poi_long_description": "Historic brewery complex now offering dining, shopping, a farmers' market & event space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-826e-760a-a624-c10a20410b57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd17-826e-760a-a624-c10a20410b57",
        "storage_key": "property/6767906449167660/019ffd17-826e-760a-a624-c10a20410b57.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://atpearl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7838779049543302535&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pearl",
      "poi_latitude": "29.4422257",
      "poi_longitude": "-98.4793656",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-212-7260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4ca-7482-ab08-cbd5fac2afe6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4ca-7482-ab08-cbd5fac2afe6",
        "storage_key": "property/6767906449167660/019ffd17-a4ca-7482-ab08-cbd5fac2afe6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlURq7Cj1XIYRh33NkAPwyGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_45d31561-31c5-41e9-b108-dbde25b08121",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "VIA Centro Plaza",
      "poi_type": "Transportation & Transit",
      "poi_address": "909 W Houston St, San Antonio, TX 78207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-3f30-75ce-b901-978e029246dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3f30-75ce-b901-978e029246dd",
        "storage_key": "property/6767906449167660/019ffd1d-3f30-75ce-b901-978e029246dd.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5120125305985227714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "via-centro-plaza",
      "poi_latitude": "29.4272961",
      "poi_longitude": "-98.5041623",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-299-5802",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c8-75d9-9b8e-94e897b41509",
        "storage_key": "property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAYhDWEpfXIYRwtu8lNZWDkc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_df7a35a0-f8fa-4e87-bfb1-3b22a8f3999a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "H-E-B Corporate Office Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "646 S Flores St, San Antonio, TX 78204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-92dc-75c9-b29b-5a4a512f0d3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd17-92dc-75c9-b29b-5a4a512f0d3e",
        "storage_key": "property/6767906449167660/019ffd17-92dc-75c9-b29b-5a4a512f0d3e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/static-page/heb-corporate-office-hq",
      "poi_directions_map_url": "https://maps.google.com/?cid=10485037645668446608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-corporate-office-headquarters",
      "poi_latitude": "29.417145",
      "poi_longitude": "-98.4954154",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-938-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c8-75d9-9b8e-94e897b41509",
        "storage_key": "property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHfrImLFYXIYRkHGqxi9WgpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_790ecdfa-3a73-449c-894d-a9b14aa45af9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Frost Bank",
      "poi_type": "Major Employers & Offices",
      "poi_address": "111 W Houston St Suite 100, San Antonio, TX 78205, USA",
      "poi_short_description": "Long-standing financial institution providing a range of banking and investment services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-4009-776f-aec4-356707c6d4b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-4009-776f-aec4-356707c6d4b8",
        "storage_key": "property/6767906449167660/019ffd1d-4009-776f-aec4-356707c6d4b8.webp",
        "width": 624,
        "height": 351
      },
      "poi_business_url": "https://locations.frostbank.com/san-antonio/111-w.-houston-st.?utm_source=Yext&utm_medium=LocationsPages",
      "poi_directions_map_url": "https://maps.google.com/?cid=9716043397336105904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frost-bank",
      "poi_latitude": "29.4268929",
      "poi_longitude": "-98.4948819",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 800-513-7678",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-4b3d-74bb-a21d-a6e0b4883e9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-4b3d-74bb-a21d-a6e0b4883e9c",
        "storage_key": "property/6767906449167660/019ffd1d-4b3d-74bb-a21d-a6e0b4883e9c.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJmawfoVJfXIYRsIN_-P1R1oY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bank"
    },
    {
      "id": "custom_cf273084-fc44-4f32-a5b5-1b4947194473",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "San Antonio City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Military Plaza #4, San Antonio, TX 78205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-9b14-73ca-aca4-09903c4e9600.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd17-9b14-73ca-aca4-09903c4e9600",
        "storage_key": "property/6767906449167660/019ffd17-9b14-73ca-aca4-09903c4e9600.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sanantonio.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8903974517540474478&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-city-hall",
      "poi_latitude": "29.4245868",
      "poi_longitude": "-98.4951446",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-207-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a745-70cf-8b77-76320b681e65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a745-70cf-8b77-76320b681e65",
        "storage_key": "property/6767906449167660/019ffd17-a745-70cf-8b77-76320b681e65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUSdxOw5DXIYRbk4h_6VFkXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_f57121a9-4d9b-490f-a2a6-4ce01f808446",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Bexar County Courthouse, 100 Dolorosa St B10.2, San Antonio, TX 78205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-4066-7635-9e1c-dbb0ffb31702.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-4066-7635-9e1c-dbb0ffb31702",
        "storage_key": "property/6767906449167660/019ffd1d-4066-7635-9e1c-dbb0ffb31702.webp",
        "width": 1280,
        "height": 1053
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7237580673085542371&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "courthouse",
      "poi_latitude": "29.423782",
      "poi_longitude": "-98.4935257",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a745-70cf-8b77-76320b681e65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a745-70cf-8b77-76320b681e65",
        "storage_key": "property/6767906449167660/019ffd17-a745-70cf-8b77-76320b681e65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNx-aE61YXIYR4w9_nEYNcWQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_6bd60da9-ea6c-47c8-b13f-9f6dd46525b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Federal Building and U.S. Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "615 E Houston St #598, San Antonio, TX 78205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-437a-731b-b484-e3403f74d22c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-437a-731b-b484-e3403f74d22c",
        "storage_key": "property/6767906449167660/019ffd1d-437a-731b-b484-e3403f74d22c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.txwb.uscourts.gov/san-antonio-division",
      "poi_directions_map_url": "https://maps.google.com/?cid=11081499013554739306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "federal-building-and-us-courthouse",
      "poi_latitude": "29.4270051",
      "poi_longitude": "-98.4862919",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-472-6720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a745-70cf-8b77-76320b681e65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a745-70cf-8b77-76320b681e65",
        "storage_key": "property/6767906449167660/019ffd17-a745-70cf-8b77-76320b681e65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8WZUPVVfXIYRapjF-aNkyZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_450e52a5-c4df-4c82-a516-a25433be9d96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Henry B. González Convention Center",
      "poi_type": "Entertainment",
      "poi_address": "900 E Market St, San Antonio, TX 78205, USA",
      "poi_short_description": "Spacious downtown spot for basketball-themed conventions, plus professional events and conferences.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-4379-764d-841a-320b8a2a3349.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-4379-764d-841a-320b8a2a3349",
        "storage_key": "property/6767906449167660/019ffd1d-4379-764d-841a-320b8a2a3349.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sahbgcc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11158774918249612784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "henry-b-gonzlez-convention-center",
      "poi_latitude": "29.4204074",
      "poi_longitude": "-98.4836727",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-207-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c8-75d9-9b8e-94e897b41509",
        "storage_key": "property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJzxIBqpYXIYR8IXOmqru25o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convention_center"
    },
    {
      "id": "custom_83fbed46-3c82-4fd5-ad9f-38c8e38e7d2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "CPS Energy Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 McCullough Ave, San Antonio, TX 78215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-9d01-70dd-b7d5-881d0c6ed3da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd17-9d01-70dd-b7d5-881d0c6ed3da",
        "storage_key": "property/6767906449167660/019ffd17-9d01-70dd-b7d5-881d0c6ed3da.webp",
        "width": 1280,
        "height": 835
      },
      "poi_business_url": "https://www.cpsenergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12925321917083403948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cps-energy-headquarters",
      "poi_latitude": "29.4323996",
      "poi_longitude": "-98.4861771",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-353-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c8-75d9-9b8e-94e897b41509",
        "storage_key": "property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVlaVZfXIYRrMZTY833X7M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4c150352-1c50-4318-8130-5ea9878ed00f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "San Antonio Water System",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2800 US-281, San Antonio, TX 78212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-41df-741f-93c0-4d2b3eb984ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-41df-741f-93c0-4d2b3eb984ea",
        "storage_key": "property/6767906449167660/019ffd1d-41df-741f-93c0-4d2b3eb984ea.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.saws.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2485795533149395699&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-water-system",
      "poi_latitude": "29.4582592",
      "poi_longitude": "-98.480136",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-704-7297",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a745-70cf-8b77-76320b681e65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a745-70cf-8b77-76320b681e65",
        "storage_key": "property/6767906449167660/019ffd17-a745-70cf-8b77-76320b681e65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRRnk5Yj1XIYR81qf-d1RfyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_0a78c11b-e523-4977-a7d6-0461a901aa84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "poi_name": "Valero",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Valero Way, San Antonio, TX 78249, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1d-44a5-739d-a3cd-11e0ace9933a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-44a5-739d-a3cd-11e0ace9933a",
        "storage_key": "property/6767906449167660/019ffd1d-44a5-739d-a3cd-11e0ace9933a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.valero.com/ourbusiness/ourlocations/offices/pages/valerocorporateheadquarters.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=16201185604516536043&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valero",
      "poi_latitude": "29.5869869",
      "poi_longitude": "-98.6070957",
      "poi_miles_from_property": "14.9",
      "poi_walking_minutes": "5 hours 42 mins",
      "poi_biking_minutes": "2 hours 0 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 210-345-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd17-a4c8-75d9-9b8e-94e897b41509",
        "storage_key": "property/6767906449167660/019ffd17-a4c8-75d9-9b8e-94e897b41509.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv1eqHI5mXIYR615hQXgs1uA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_a756e65e086a6a343ff09fd5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e2b90aa817f277f05eb2bcf7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f91eac9d31151b7b077ac95e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3a3c1c698bbeaf3bf87683f9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_bd0db76a3281a0616442ac12",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c0332b66323a821923b484b3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_6d010b07-2dbd-4d60-966d-e816dc04a188",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "rating": "5.0",
      "name": "Travis Scott",
      "text": "Been living here for about 5 months now. This place is pretty great as far as apartments go. Maintenance has been quick, effective, and kind. Management is helpful, responsive, and very communicative for things like local events, deadlines, and emergencies. The thick concrete walls insulate sound and temperature remarkably well. The complex itself is generally well maintained. Each building has its own unique architecture that gives some character. The greenery growing on some of the buildings is awesome. I like seeing all the little gardens and personal decorations neighbors have outside their apartments. The gyms are pretty well equipped. Neighbors are generally friendly and sociable. The location is about as walk-able as San Antonio gets. I haven't had any problems with things related to roaches, HVAC, or petty thievery/car break-ins. Overall, my stay at 1221 Broadway has been a pretty great experience. Would recommend to a friend.\n\nBad things to note:\n- I feel bad for the people living near Porta Rossa bar on Broadway. The bar can get loud and rowdy. I don't imagine the apartment is insulating all of that noise.\n\n- General downtown noises can be obtrusive at times. This just comes with living downtown.\n\n- City events like fiesta occasionally close parts of downtown and make navigating around the apartment complex a little more challenging. Also comes with living downtown.",
      "date": "2026-05-20",
      "title": ""
    },
    {
      "id": "custom_f5064fdf-56cd-4f30-bdde-ff1bf80d513d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "rating": "5.0",
      "name": "Todd Prins",
      "text": "I waited a year to post. Maintenance is great here and the location can't be beat. I truly appreciate the \"industrial\" esthetic and if you like it you'll love it here. The staff has always been friendly and helpful and the rules are enforced. I have and would recommend 1221.",
      "date": "2026-07-22",
      "title": ""
    },
    {
      "id": "custom_aca64e22-74aa-41ee-8cd5-2c14aa5b3f98",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "rating": "5.0",
      "name": "Angele Shoaf",
      "text": "Living at Broadway Lofts has been such an amazing experience! I absolutely love it here. Cynthia has been incredible from the start — always helpful, professional, and genuinely caring. The community is awesome, and you really can’t beat the location. Being in the center of everything and so close to the River Walk makes it even better. Highly recommend for anyone looking for a fun, convenient, and welcoming place to live!",
      "date": "2026-05-22",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_2ef3d1e9cc410c050fdf2147",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1b-a973-77ca-b022-d4e28249d47c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ffd1b-a973-77ca-b022-d4e28249d47c",
        "storage_key": "property/6767906449167660/019ffd1b-a973-77ca-b022-d4e28249d47c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Studio, 1BA - 637 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=H2ZQpm7LxLy"
    },
    {
      "id": "ec_634b18be5774b77f929e1578",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1b-a8dd-7219-ae4a-a4a21e7d82e0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ffd1b-a8dd-7219-ae4a-a4a21e7d82e0",
        "storage_key": "property/6767906449167660/019ffd1b-a8dd-7219-ae4a-a4a21e7d82e0.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Studio, 1BA - 593 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Xp2qiY2sZgH"
    },
    {
      "id": "ec_e669a420a56a08d908f42bc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1b-a8de-76cd-b9b0-b70e4eb7af94.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ffd1b-a8de-76cd-b9b0-b70e4eb7af94",
        "storage_key": "property/6767906449167660/019ffd1b-a8de-76cd-b9b0-b70e4eb7af94.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 686 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=qK5xrNqYfZi"
    },
    {
      "id": "ec_68737fb89649c8ec76bee53d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1b-a886-732e-8768-70d44971dadd.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ffd1b-a886-732e-8768-70d44971dadd",
        "storage_key": "property/6767906449167660/019ffd1b-a886-732e-8768-70d44971dadd.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 856 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=8rXiEFQt7EN"
    },
    {
      "id": "ec_4387b20f5f7e47f2657df9fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1b-a8fb-74c9-9117-9b8124271025.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ffd1b-a8fb-74c9-9117-9b8124271025",
        "storage_key": "property/6767906449167660/019ffd1b-a8fb-74c9-9117-9b8124271025.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Open-Air Olympic Lifting and Boxing Gym",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=sZLjGHjk7QW"
    },
    {
      "id": "ec_99b035e4f128d66c6f00a2d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167660/019ffd1b-af0e-7179-97be-e738938c2381.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ffd1b-af0e-7179-97be-e738938c2381",
        "storage_key": "property/6767906449167660/019ffd1b-af0e-7179-97be-e738938c2381.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Courtyard Pool",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ZWjDaZgtfS9"
    }
  ],
  "faqs": [
    {
      "id": "custom_36aa7683-a4b5-4e3e-8070-56c84496f564",
      "question": "What is the best neighborhood to rent an apartment in San Antonio, TX?",
      "answer": "San Antonio has many distinct neighborhoods to choose from and has something for everyone. Here are some of the best places to live when you're looking for a San Antonio apartment for rent:\n\nRiver North District\nA vibrant urban corridor along the Museum Reach of the River Walk, with walkable access to world-class dining, the Pearl District, and the San Antonio Museum of Art. 1221 Broadway Lofts is perfectly positioned in this dynamic area.\n\nDowntown San Antonio\nThe energetic core of the city, where residents enjoy live music at the Tobin Center for the Performing Arts and endless dining and entertainment along the iconic River Walk.\n\nKing William\nThis historic neighborhood south of downtown is known for independent galleries, acclaimed restaurants, and the Blue Star Arts Complex.\n\nMonte Vista\nWith tree-lined streets and beautiful historic architecture, this neighborhood offers a quiet residential feel just minutes from downtown and San Antonio College.",
      "category": "",
      "source": "custom"
    },
    {
      "id": "custom_3fdea0d9-ea52-4357-9bad-c6220303a050",
      "question": "What makes living in San Antonio, TX unique?",
      "answer": "San Antonio offers a rare blend of deep cultural heritage and modern urban energy. Whether you're looking for walkable city living, riverfront adventure, or proximity to major employers, here are some of the unique features to consider:\n\nIdeal Location\nFrom 1221 Broadway Lofts, you're in the heart of the River North District with easy access to I-37 and I-35. Downtown San Antonio, the Pearl, and the River Walk are all right outside your door.\n\nOutdoor Adventures\nThe San Antonio River Walk runs right past 1221 Broadway Lofts, giving residents easy access to walking and biking trails, public art installations, and Brackenridge Park.\n\nPremium Living\nSan Antonio is home to two Fortune 500 headquarters, Valero Energy and USAA, and was ranked the 11th best city in the nation for Gen Z residents in 2025 by CommercialCafe.\n\nLocal Community\nLiving at 1221 Broadway Lofts places you just a 10-minute walk from the Pearl District and its exceptional chef-driven restaurants, unique specialty shops, and local culinary campus.",
      "category": "",
      "source": "custom"
    },
    {
      "id": "custom_9c26bb39-11d5-4d03-a125-379834309213",
      "question": "What are some things to do in San Antonio, TX?",
      "answer": "There are many fun activities to do in San Antonio! 1221 Broadway Lofts' location in the River North District puts residents in the heart of the city's most walkable and culture-rich corridor. Major attractions in the area include:\n\n- San Antonio River Walk\n- The Pearl District\n- San Antonio Museum of Art (SAMA)\n- Brackenridge Park\n- San Antonio Zoo\n- The Alamo\n- Tobin Center for the Performing Arts\n- Market Square (El Mercado)\n- Japanese Tea Garden\n- Blue Star Arts Complex",
      "category": "",
      "source": "custom"
    },
    {
      "id": "custom_278727df-52b6-472e-9ad7-39a7b2fc38b5",
      "question": "How close is San Antonio, TX to major employers?",
      "answer": "1221 Broadway Lofts is only minutes from San Antonio's top employers. The property's proximity to I-37 and I-35 gives easy access to healthcare, education, and corporate employers, like:\n\n- San Antonio College\n- Methodist Hospital Metropolitan\n- University of Texas at San Antonio\n- USAA\n- Valero Energy\n- H-E-B\n- Joint Base San Antonio\n- Rackspace Technology",
      "category": "",
      "source": "custom"
    },
    {
      "id": "custom_ebef0146-639f-4192-b2c7-c7a4a58d48fc",
      "question": "What amenities does 1221 Broadway Lofts offer?",
      "answer": "At 1221 Broadway Lofts, you'll find a variety of amenities that make living in vibrant San Antonio even better, such as:\n\nRooftop Pool with Panoramic Downtown Views\nAt 1221 Broadway Lofts, you can unwind at the rooftop pool while taking in sweeping views of the downtown San Antonio skyline, with free Wi-Fi included.\n\nDual Fitness Facilities with Open-Air Olympic Lifting and Boxing Gym\nFrom the 24-hour indoor cardio and strength training center to the one-of-a-kind open-air Olympic lifting and boxing gym, 1221 Broadway Lofts has every workout covered.\n\nFive Landscaped Courtyards with BBQ and Picnic Areas\nResidents enjoy five beautifully maintained outdoor courtyards with seating and grilling stations, perfect for relaxing or entertaining under the Texas sky.\n\nPet-Friendly Fenced Dog Park and Resident Lounge\nAt 1221 Broadway Lofts, pets have their own fully fenced dog park for safe off-leash play, and the resident lounge with a wireless sound system gives the whole community a stylish place to connect.",
      "category": "",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_b9525d1acbf8f32306360591",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "yardi",
      "external_id": "2613834",
      "pet_type": "all",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 0,
      "description": "We understand that pets are part of the family. That's why your pets are welcome to join our community at 1221 Broadway.",
      "restrictions": "We are proud partners with PetScreening.com! Pet rents range; please contact the office for details on rents and size/breed restrictions."
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a04a29-4a10-7438-8e19-83a51aa4ac19",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "1221 Broadway Lofts Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660"
    },
    {
      "lead_collector_id": "01a04a29-4aa6-779c-99d0-94a29a0fad13",
      "lead_source": "LANDING_PAGE",
      "name": "1221 Broadway Lofts Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "page_item_url": "rooftop-pool-apartments-downtown-san-antonio",
      "search_query": "rooftop pool apartments downtown san antonio",
      "category": "Amenity",
      "h1_title": "Rooftop Pool Apartments in Downtown San Antonio",
      "h2_subtitle": "Discover luxurious rooftop pool apartments in the heart of Downtown San Antonio. Enjoy the stunning skyline views from your premium residence at 1221 Broadway Lofts.",
      "page_copy": "Experience the ultimate urban living at 1221 Broadway Lofts, where luxury meets convenience in downtown San Antonio. Our rooftop pool offers unparalleled panoramic views of the city's vibrant skyline, making it the perfect spot to unwind after a long day. Whether you're swimming laps in the tranquil pool or lounging poolside, our amenity promises a refreshing escape in the heart of the city.\n\nNestled in Downtown San Antonio, our apartments boast top-notch features including granite countertops and the added comfort of a parking garage with reserved spots. Select units also provide breathtaking views of the downtown area and Riverwalk to enhance your living experience. Come explore the best rooftop pool apartments downtown San Antonio has to offer and transform your lifestyle at 1221 Broadway Lofts.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rooftop Pool Apartments Downtown San Antonio",
      "seo_description": "Discover rooftop pool apartments in downtown San Antonio at 1221 Broadway Lofts, with luxury amenities and stunning skyline views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "page_item_url": "luxury-apartments-gym-bexar-county",
      "search_query": "luxury apartments with gym in bexar county",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Gym in Bexar County",
      "h2_subtitle": "Explore luxury apartments with a gym in Bexar County. Experience unmatched amenities and urban charm at 1221 Broadway Lofts in Downtown San Antonio.",
      "page_copy": "Located in the heart of Bexar County, 1221 Broadway Lofts defines upscale living with its exceptional amenities and prime downtown San Antonio location. Our residents enjoy access to state-of-the-art fitness facilities, ensuring you have everything you need to maintain your active lifestyle without leaving home. These luxury apartments not only boast a gym but are also equipped with elegant features like granite countertops and offer striking views of the Riverwalk and downtown skyline in select units.\n\nAt 1221 Broadway Lofts, you will find more than just a place to live; you will embrace a refined lifestyle surrounded by lush greenery in our tranquil courtyard pool area and enjoy breathtaking views from our stunning rooftop pool. The convenience of a parking garage with reserved spots further complements the luxurious living experience. Elevate your apartment living and explore the sophistication of luxury apartments with a gym right in the lively center of Bexar County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Gym in Bexar County",
      "seo_description": "Find luxury apartments with a gym in Bexar County at 1221 Broadway Lofts. Enjoy top amenities and a prime downtown San Antonio location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "page_item_url": "apartments-with-parking-78215",
      "search_query": "apartments with parking in 78215",
      "category": "Amenity",
      "h1_title": "Apartments with Parking in 78215",
      "h2_subtitle": "Discover convenient apartments with parking in the 78215 area. Enjoy the blend of city living and reserved parking at 1221 Broadway Lofts.",
      "page_copy": "1221 Broadway Lofts offers an unparalleled urban living experience in the vibrant 78215 area, complete with the convenience of a dedicated parking garage. Located in the heart of downtown San Antonio, our residents benefit from reserved parking spots, alleviating the stresses of finding street parking. This premium feature perfectly complements the upscale lifestyle offered at our community.\n\nWith breathtaking views of the downtown skyline and stunning Riverwalk vistas from select units, our apartments are a haven of luxury and convenience. Relax by the rooftop pool or unwind in our lush, green courtyard pool area. Our modern interiors, featuring granite countertops, blend seamlessly with top-notch amenities to create a sophisticated living environment. Choose 1221 Broadway Lofts—your ideal choice for apartments with parking in the 78215 zip code.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Parking in 78215",
      "seo_description": "Explore apartments with parking in 78215 at 1221 Broadway Lofts. Enjoy convenience and luxury in downtown San Antonio with reserved parking spots.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "page_item_url": "riverwalk-view-apartments-san-antonio",
      "search_query": "riverwalk view apartments san antonio",
      "category": "Amenity",
      "h1_title": "Riverwalk View Apartments in San Antonio",
      "h2_subtitle": "Discover the charm of Riverwalk view apartments in San Antonio. Enjoy scenic views and luxury living at 1221 Broadway Lofts in the heart of the city.",
      "page_copy": "Experience the allure of Riverwalk view apartments at 1221 Broadway Lofts, where luxury and breathtaking vistas converge in downtown San Antonio. Our select units offer stunning views of the iconic Riverwalk, providing a unique perspective of this vibrant city. Watch the tranquil waters reflect the lively energy of San Antonio while you relax in your elegant apartment.\n\nNestled in the heart of the city, 1221 Broadway Lofts combines modern living with premier amenities. From granite countertops to our tranquil courtyard pool surrounded by lush greenery and flowers, every detail is crafted to enhance your lifestyle. Enjoy a refreshing swim in our rooftop pool with panoramic downtown views, and the convenience of a parking garage with reserved spots. Discover the epitome of urban luxury with our Riverwalk view apartments in San Antonio.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Riverwalk View Apartments in San Antonio",
      "seo_description": "Find Riverwalk view apartments in San Antonio at 1221 Broadway Lofts, offering luxury living with stunning views and upscale amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "page_item_url": "studio-apartments-downtown-san-antonio",
      "search_query": "studio apartments downtown san antonio",
      "category": "Floorplan",
      "h1_title": "Studio Apartments Downtown San Antonio",
      "h2_subtitle": "Find stylish studio apartments in downtown San Antonio at 1221 Broadway Lofts. Enjoy modern amenities and vibrant city living at your doorstep.",
      "page_copy": "1221 Broadway Lofts offers contemporary studio apartments in the heart of downtown San Antonio, designed to cater to urban lifestyles. Our studio apartments provide an open and flexible living space, perfect for those who appreciate efficient living coupled with modern design elements. Residents enjoy the vibrant energy of the city's downtown while residing in a community equipped with impressive amenities.\n\nLiving at 1221 Broadway Lofts means you'll have access to a stunning rooftop pool with expansive views of the city's skyline, as well as a tranquil courtyard pool surrounded by lush greenery, flowers, and hanging plants. The interior features, such as granite countertops, complement the high-end lifestyle. Alongside these amenities, residents have the advantage of a reserved parking garage, eliminating the usual downtown parking concerns. Choose our studio apartments for a blend of convenience, style, and downtown excitement.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments Downtown San Antonio",
      "seo_description": "Explore stylish studio apartments in downtown San Antonio at 1221 Broadway Lofts, featuring modern amenities and an unbeatable location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-bexar-county",
      "search_query": "1 bedroom apartments bexar county",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Bexar County",
      "h2_subtitle": "Discover modern 1 bedroom apartments in Bexar County at 1221 Broadway Lofts. Experience comfortable city living with premium amenities.",
      "page_copy": "At 1221 Broadway Lofts, our 1 bedroom apartments offer a perfect blend of comfort and style in the bustling heart of Bexar County. Each apartment is thoughtfully designed with modern conveniences and finishes, such as granite countertops, to create a welcoming home environment. Situated in downtown San Antonio, our lofts provide easy access to the vibrant cultural and entertainment scene around the iconic Riverwalk.\n\nResidents of our 1 bedroom apartments enjoy exclusive amenities, including a stunning rooftop pool with panoramic views of the downtown skyline and a quiet courtyard pool surrounded by lush greenery. Additionally, the convenience of a parking garage with reserved spots ensures a hassle-free living experience in an urban setting. Choose 1221 Broadway Lofts for a refined lifestyle in San Antonio's most dynamic district.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Bexar County",
      "seo_description": "Explore modern 1 bedroom apartments in Bexar County at 1221 Broadway Lofts, offering city convenience and premier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "page_item_url": "2-bedroom-lofts-near-78215",
      "search_query": "2 bedroom lofts near 78215",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Lofts Near 78215",
      "h2_subtitle": "Explore spacious 2 bedroom lofts near the 78215 ZIP code at 1221 Broadway Lofts. Enjoy a blend of modern living and downtown convenience.",
      "page_copy": "Discover the allure of urban living with our 2 bedroom lofts located just a stone's throw away from the vibrant heart of San Antonio's 78215 area at 1221 Broadway Lofts. Our lofts are designed to offer spacious layouts that combine style and functionality, perfect for those seeking a dynamic lifestyle with ample room to thrive. Each unit boasts high-end finishes like granite countertops, enhancing the modern living experience.\n\nPositioned in the bustling downtown area, our residents enjoy unmatched access to local attractions including the lively Riverwalk. Adding to the appeal is a rooftop pool boasting panoramic city views, and a serene courtyard pool surrounded by lush greenery for those moments of relaxation. Secure, reserved parking garage options add to the convenience, making 1221 Broadway Lofts an ideal choice for discerning renters in search of 2 bedroom lofts near the 78215 ZIP code.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Lofts Near 78215",
      "seo_description": "Discover spacious 2 bedroom lofts near the 78215 area at 1221 Broadway Lofts, offering modern living and downtown San Antonio convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "page_item_url": "apartments-near-san-antonio-college-downtown",
      "search_query": "apartments near San Antonio College Downtown",
      "category": "School",
      "h1_title": "Apartments Near San Antonio College Downtown",
      "h2_subtitle": "Discover modern apartments near San Antonio College Downtown at 1221 Broadway Lofts. Enjoy convenient living close to educational hubs and city attractions.",
      "page_copy": "Located just minutes from San Antonio College Downtown, 1221 Broadway Lofts offers the perfect base for students and professionals alike. Our apartments are designed with modern aesthetics and practical amenities that cater to contemporary lifestyles. The proximity to the college makes commuting a breeze, allowing residents to balance educational pursuits with the vibrant downtown lifestyle of San Antonio.\n\nAt 1221 Broadway Lofts, residents can relish in upscale features such as granite countertops and enjoy exclusive access to amenities like our stunning rooftop pool with panoramic views of the downtown skyline. A tranquil courtyard pool surrounded by lush greenery provides a peaceful retreat amid the city's energy. With a convenient parking garage offering reserved spots, living here simplifies urban life while keeping you close to both academic and cultural attractions.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near San Antonio College Downtown",
      "seo_description": "Explore modern living at 1221 Broadway Lofts, with convenient apartments near San Antonio College Downtown, offering premium amenities and an ideal location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "page_item_url": "lofts-close-to-st-philips-college-san-antonio",
      "search_query": "lofts close to St. Philip's College San Antonio",
      "category": "School",
      "h1_title": "Lofts Close to St. Philip's College San Antonio",
      "h2_subtitle": "Find chic lofts close to St. Philip's College in San Antonio at 1221 Broadway Lofts. Enjoy proximity to education and urban attractions.",
      "page_copy": "1221 Broadway Lofts provides an exceptional living experience just a short drive from St. Philip's College, making it an ideal choice for students and faculty seeking convenience and style. Our lofts are crafted with modern design elements and feature high-end finishes, including granite countertops, offering a sophisticated yet comfortable home environment. \n\nResidents benefit from easy access to San Antonio's vibrant downtown scene while enjoying the tranquility provided by two exclusive pools – a rooftop oasis with breathtaking city views and a serene courtyard surrounded by lush landscapes. With a secure parking garage featuring reserved spots, these lofts not only offer proximity to St. Philip's College but also seamless connectivity to the city's numerous amenities and attractions. Choose 1221 Broadway Lofts for a balanced lifestyle combining urban convenience with peaceful living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lofts Close to St. Philip's College San Antonio",
      "seo_description": "Explore chic lofts near St. Philip's College at 1221 Broadway Lofts. Enjoy both proximity to education and downtown San Antonio's vibrant attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "page_item_url": "apartments-near-university-of-the-incarnate-word-tx",
      "search_query": "apartments near University of the Incarnate Word TX",
      "category": "School",
      "h1_title": "Apartments Near University of the Incarnate Word TX",
      "h2_subtitle": "Discover well-appointed apartments near the University of the Incarnate Word TX at 1221 Broadway Lofts. Enjoy a blend of convenience and urban living.",
      "page_copy": "1221 Broadway Lofts is perfectly located for anyone studying or working at the University of the Incarnate Word in TX. Offering a seamless blend of comfort and style, our apartments cater to those seeking modern amenities close to campus. Situated in downtown San Antonio, our residents enjoy easy access to both educational pursuits and vibrant city life.\n\nOur property features stylish interiors with granite countertops and provides access to premium amenities such as a rooftop pool with panoramic downtown views and a serene courtyard pool. Reserved parking options in our secure garage further enhance the convenience of living here. Choose 1221 Broadway Lofts for convenient, luxurious living with close connections to the University of the Incarnate Word and all the cultural vibrancy San Antonio has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of the Incarnate Word TX",
      "seo_description": "Find ideal apartments near the University of the Incarnate Word TX at 1221 Broadway Lofts. Enjoy modern living, prime location, and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "page_item_url": "lofts-close-to-st-marys-university-bexar-county",
      "search_query": "lofts close to St. Mary's University Bexar County",
      "category": "School",
      "h1_title": "Lofts Close to St. Mary's University Bexar County",
      "h2_subtitle": "Explore modern lofts close to St. Mary's University in Bexar County at 1221 Broadway Lofts. Perfect for students and faculty seeking urban convenience.",
      "page_copy": "1221 Broadway Lofts offers a premier living environment conveniently located near St. Mary's University in Bexar County. Our lofts combine stylish design with functional space, making them ideal for students, faculty, and professionals who value easy access to both academic commitments and the energetic atmosphere of downtown San Antonio.\n\nResidents at 1221 Broadway Lofts enjoy premium features like granite countertops and exclusive amenities such as a rooftop pool that showcases breathtaking views of San Antonio's skyline. The tranquil courtyard pool provides a relaxing escape, while reserved parking in our secure garage adds to the convenience. Experience the best of city living with proximity to St. Mary's University, cultural attractions, and dining options all around.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lofts Close to St. Mary's University Bexar County",
      "seo_description": "Discover modern lofts near St. Mary's University, Bexar County at 1221 Broadway Lofts. Enjoy top amenities and an ideal location for students and professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "page_item_url": "apartments-near-trinity-university-78215",
      "search_query": "apartments near Trinity University 78215",
      "category": "School",
      "h1_title": "Apartments Near Trinity University 78215",
      "h2_subtitle": "Find contemporary apartments near Trinity University in 78215 at 1221 Broadway Lofts. Experience the best of urban conveniences and high-end living.",
      "page_copy": "1221 Broadway Lofts is strategically situated near Trinity University in the 78215 area, offering a perfect blend of comfort and proximity for students and educators alike. Our apartments feature modern amenities and high-end finishes, including elegant granite countertops, ensuring a luxurious living experience in the heart of San Antonio.\n\nResidents enjoy stunning downtown views from our rooftop pool and tranquility from our lush courtyard pool. With reserved parking in our secure garage, living at these apartments brings unparalleled convenience. Just minutes away from downtown's vibrant culture and entertainment, 1221 Broadway Lofts is your gateway to an enriched lifestyle near Trinity University.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Trinity University 78215",
      "seo_description": "Live near Trinity University in 78215 at 1221 Broadway Lofts. Enjoy stylish apartments with premium amenities and an ideal San Antonio location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "page_item_url": "apartments-near-brooke-army-medical-center-san-antonio",
      "search_query": "apartments near Brooke Army Medical Center San Antonio",
      "category": "Hospital",
      "h1_title": "Apartments Near Brooke Army Medical Center",
      "h2_subtitle": "Explore 1221 Broadway Lofts, offering premium apartments near Brooke Army Medical Center in San Antonio. Ideal for healthcare professionals seeking convenience.",
      "page_copy": "1221 Broadway Lofts provides an exceptional living environment for those working at Brooke Army Medical Center in San Antonio. Our apartments combine modern design and comfort with a location that offers easy commutes, making them perfect for busy healthcare professionals and staff. Nestled in the vibrant downtown area, you'll enjoy access to both work and leisure activities.\n\nWith top-tier amenities like granite countertops, a rooftop pool with city views, and a serene courtyard pool, we cater to a comfortable lifestyle. Reserved parking in our secure garage makes coming home a breeze. Choose 1221 Broadway Lofts for luxury living near Brooke Army Medical Center and experience the convenience and style you deserve.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Brooke Army Medical Center",
      "seo_description": "Find upscale apartments near Brooke Army Medical Center, San Antonio at 1221 Broadway Lofts. Experience modern living with top amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "page_item_url": "apartments-near-san-antonio-river-walk-downtown",
      "search_query": "apartments near san antonio river walk downtown",
      "category": "Park",
      "h1_title": "Apartments Near San Antonio River Walk Downtown",
      "h2_subtitle": "Discover luxury apartments near the San Antonio River Walk downtown at 1221 Broadway Lofts. Embrace urban living with charming perks and amenities.",
      "page_copy": "1221 Broadway Lofts is the perfect choice for anyone looking to reside near the iconic San Antonio River Walk downtown. Our apartments offer sophisticated living spaces with modern interiors, allowing residents to immerse themselves in the heart of San Antonio's lively downtown scene. With the River Walk just steps away, you'll have quick access to its charming pathways, restaurants, and cultural attractions.\n\nOur community features a rooftop pool with stunning views of the downtown skyline and a tranquil courtyard surrounded by lush greenery. Enjoy the convenience of reserved parking in our onsite garage. Choose our vibrant apartments near the San Antonio River Walk and indulge in both luxury and convenience at 1221 Broadway Lofts.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near San Antonio River Walk Downtown",
      "seo_description": "Live near San Antonio River Walk downtown at 1221 Broadway Lofts. Enjoy luxury living with vibrant city access and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "page_item_url": "lofts-close-to-japanese-tea-garden-san-antonio",
      "search_query": "lofts close to japanese tea garden san antonio",
      "category": "Park",
      "h1_title": "Lofts Close to Japanese Tea Garden San Antonio",
      "h2_subtitle": "Experience upscale loft living close to the Japanese Tea Garden in San Antonio. Find your new home at 1221 Broadway Lofts and enjoy serene surroundings.",
      "page_copy": "1221 Broadway Lofts offers a unique living opportunity near the serene Japanese Tea Garden in San Antonio. These lofts boast a combination of urban sophistication and tranquil surroundings, making them ideal for those who appreciate nature and luxury alike. Just a short drive from the lush landscapes of the garden, residents have access to peaceful strolls and inspiring views.\n\nEnjoy our stunning amenities like the rooftop pool with panoramic city views, as well as a serene courtyard pool area perfect for relaxation. Each loft features high-end finishes including granite countertops. Benefit from the convenience of reserved parking in our secure garage, ensuring a seamless lifestyle at 1221 Broadway Lofts, close to San Antonio's beautiful Japanese Tea Garden.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lofts Close to Japanese Tea Garden San Antonio",
      "seo_description": "Live at 1221 Broadway Lofts near the Japanese Tea Garden, San Antonio. Experience luxury living with nature at your doorstep.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "page_item_url": "apartments-by-san-antonio-botanical-garden-tx",
      "search_query": "apartments by san antonio botanical garden tx",
      "category": "Park",
      "h1_title": "Apartments by San Antonio Botanical Garden TX",
      "h2_subtitle": "Enjoy luxurious living in apartments by the San Antonio Botanical Garden TX at 1221 Broadway Lofts. Embrace nature and city sophistication.",
      "page_copy": "At 1221 Broadway Lofts, we're proud to offer stunning apartments just a short distance from the San Antonio Botanical Garden TX. Our community is perfect for those who love the tranquility of nature, paired with the vibrant life of the city. Explore the diverse plant displays and scenic landscapes of the Botanical Garden, while enjoying the urban lifestyle offered by our downtown location.\n\nResidents will appreciate upscale amenities such as the rooftop pool, offering breathtaking views of the downtown skyline, and a lush courtyard pool area for relaxation. Each apartment features modern touches like granite countertops and the option of reserved parking. Choose 1221 Broadway Lofts, where nature and luxury living meet near the breathtaking San Antonio Botanical Garden.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by San Antonio Botanical Garden TX",
      "seo_description": "Find upscale living at 1221 Broadway Lofts, near San Antonio Botanical Garden TX. Enjoy nature and city life with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167660",
      "source": "custom",
      "page_item_url": "downtown-san-antonio-apartments-near-woodlawn-lake-park",
      "search_query": "downtown san antonio apartments near woodlawn lake park",
      "category": "Park",
      "h1_title": "Downtown San Antonio Apartments Near Woodlawn Lake Park",
      "h2_subtitle": "Experience vibrant downtown living in San Antonio apartments near Woodlawn Lake Park. Enjoy an active lifestyle at 1221 Broadway Lofts.",
      "page_copy": "1221 Broadway Lofts offers the ideal blend of urban excitement and natural beauty, situated not far from the scenic Woodlawn Lake Park. Our downtown San Antonio apartments provide a perfect location for those eager to enjoy both city life and the peaceful environments of nearby parks. Residents can take pleasure in the park's trails and wide-open spaces while also benefiting from our property's prime downtown position.\n\nOur community features stunning amenities such as a rooftop pool with sweeping views of San Antonio's skyline and a serene courtyard pool. Enjoy the comfort of granite countertops in each apartment as well as reserved parking options. Choose a lifestyle that caters to both your urban and recreational desires at 1221 Broadway Lofts, conveniently located near Woodlawn Lake Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Downtown San Antonio Apartments Near Woodlawn Lake Park",
      "seo_description": "Live in downtown San Antonio at 1221 Broadway Lofts, near Woodlawn Lake Park. Experience city convenience with natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "brianna@repli360.com"
    },
    {
      "ID": "custom_gbp_utm",
      "type": "STRING",
      "value": "https://www.1221broadway.com?utm_source=Google_Business-Profile"
    },
    {
      "ID": "custom_sem_utm",
      "type": "STRING",
      "value": "https://www.1221broadway.com?Repli=SEM"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12795363158"
    },
    {
      "ID": "custom_website_utm",
      "type": "STRING",
      "value": "https://www.1221broadway.com?utm_source=propertywebsite"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NGW6DK9M"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Prestige"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57292515134"
    },
    {
      "ID": "custom_lux_membership_url",
      "type": "STRING",
      "value": "https://www.dtsatx.com/luxmembership"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "50f8c378-b109-11f0-809d-0f36bac91c2b"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bcd1707-74a8-4db5-b1de-bca46b2e676e"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "888-739-0887"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InlmMlY0WElFeDF1L1BDRlovQnFlWFE9PSIsInZhbHVlIjoiWEdsY0pVNjNOR0oxK085bnNKT2d4dz09IiwibWFjIjoiMTUwYzk0NDJhOWVjYWQwOThjYjg3MmM5NTBlNWI0MDRkNmY0NjQyNGU5MmUwNTYyODRiYTRhZTllNDI5NTQyYSJ9"
    }
  ],
  "custom_csm": "brianna@repli360.com",
  "custom_gbp_utm": "https://www.1221broadway.com?utm_source=Google_Business-Profile",
  "custom_sem_utm": "https://www.1221broadway.com?Repli=SEM",
  "custom_repli_id": "12795363158",
  "custom_website_utm": "https://www.1221broadway.com?utm_source=propertywebsite",
  "custom_google_gtm_id": "GTM-NGW6DK9M",
  "custom_rollout_phase": "Phase 1",
  "custom_vibesites_theme": "Prestige",
  "custom_ads_subscription": "essential",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57292515134",
  "custom_lux_membership_url": "https://www.dtsatx.com/luxmembership",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "50f8c378-b109-11f0-809d-0f36bac91c2b",
  "custom_eliseai_organization_id": "4bcd1707-74a8-4db5-b1de-bca46b2e676e",
  "custom_ppc_tracking_phone_number": "888-739-0887",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InlmMlY0WElFeDF1L1BDRlovQnFlWFE9PSIsInZhbHVlIjoiWEdsY0pVNjNOR0oxK085bnNKT2d4dz09IiwibWFjIjoiMTUwYzk0NDJhOWVjYWQwOThjYjg3MmM5NTBlNWI0MDRkNmY0NjQyNGU5MmUwNTYyODRiYTRhZTllNDI5NTQyYSJ9",
  "custom_audioeye_site_id": "2a592166-bae5-464c-a768-5df7145f9aff",
  "custom_audioeye_site_hash": "a85409180a0e4cb2346348d360b66f62"
};

export const generatedAt = '2026-11-03T22:38:18.396Z';
